<template>
    <div>
        <div class="container" v-if="ListGarantidorasGeral!=''">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">Contratação vigente</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"><router-link to="/home"><i class="fa fa-home"></i></router-link></li>
                        <li class="separator"><i class="fa fa-chevron-right"></i></li>
                        <li class="nav-item"><router-link to="/ListaContratacoesVigentes">Contratações</router-link></li>
                        <li class="separator"><i class="fa fa-chevron-right"></i></li>
                        <li class="nav-item"><span>Contratação vigente</span></li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card gp-active-detail-card">
                            <div class="card-header">
                                <div class="d-flex align-items-center gp-vigente-heading">
                                    <div>
                                        <h4 class="card-title">Contratação {{ PedidosCli.pedId }}</h4>
                                        <small>Acompanhamento da garantia locatícia</small>
                                        <span v-if="PedidosCli?.cusNome"><v-icon size="14">mdi-account-outline</v-icon> Usuário: {{ PedidosCli.cusNome }}</span>
                                    </div>
                                    <div class="gp-vigente-heading-actions">
                                        <span class="gp-vigente-status"><v-icon size="15">mdi-shield-check-outline</v-icon>{{ PedidosCli.pedSituacaoPedido || 'Vigente' }}</span>
                                        <button v-if="User.garid == 0 && ListDocumentosAss?.length" type="button" class="btn gp-vigente-reprocess" :disabled="reprocessandoContrato" @click="ReprocessarContrato(ListDocumentosAss)"><v-icon size="16">mdi-file-refresh-outline</v-icon>{{ reprocessandoContrato ? 'Reprocessando...' : 'Reprocessar contrato' }}</button>
                                        <button v-if="PedidosCli.pspId == 3" type="button" class="btn gp-vigente-cancel" @click="CancelarVigencia()"><v-icon size="16">mdi-cancel</v-icon>Cancelar contratação vigente</button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body">
                                <section v-if="PedidosCli != ''" class="gp-vigente-overview">
                                    <div class="gp-vigente-overview-main">
                                        <div class="gp-vigente-access"><small>Cliente</small><strong>{{ Cliente.cliNomeEmpresa || '—' }}</strong><span>{{ Cliente.cliDocumento || 'Documento não informado' }}</span><button v-if="Cliente.cliId" type="button" title="Visualizar cliente" @click="openDialogCliente(Cliente.cliId)"><v-icon size="17">mdi-folder-open</v-icon></button></div>
                                        <div class="gp-vigente-access"><small>Garantidora / Imobiliária</small><strong>{{ DadosGarantidora.garNomeEmpresa || '—' }}</strong><span>{{ Imobiliaria.imoNomeEmpresa || '—' }}</span><button v-if="Imobiliaria.imoId" type="button" title="Visualizar imobiliária" @click="openDialogImobiliaria(Imobiliaria.imoId)"><v-icon size="17">mdi-folder-open</v-icon></button></div>
                                        <div><small>Valor contratado</small><strong class="gp-vigente-value">R$ {{ Number(PedidosCli.pedValorTotalPedido || TotalPedido || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</strong><span>{{ PedidosCli.pedCiclo > 1 ? `Renovação · ciclo ${PedidosCli.pedCiclo}` : 'Contratação inicial' }}</span></div>
                                        <div><small>Vigência</small><strong>{{ ListaPedidoItem.length ? formattedDate(ListaPedidoItem[0].pdiDataVigenciaIni) : '—' }}</strong><span>até {{ ListaPedidoItem.length ? formattedDate(ListaPedidoItem[0].pdiDataVigenciaFim) : '—' }}</span></div>
                                    </div>
                                    <div class="gp-vigente-context-grid">
                                        <article><header><v-icon size="17">mdi-map-marker-outline</v-icon><strong>Endereço da contratação</strong></header><template v-if="PedidosEndereco?.length"><strong>{{ PedidosEndereco[0].pdcEndereco }}, {{ PedidosEndereco[0].pdcNumero }}<template v-if="PedidosEndereco[0].pdcComplemento"> - {{ PedidosEndereco[0].pdcComplemento }}</template></strong><span>{{ PedidosEndereco[0].pdcBairro }} · {{ PedidosEndereco[0].pdcCidade }}/{{ PedidosEndereco[0].pdcEstado }} · CEP {{ PedidosEndereco[0].pdcCep }}</span><small>{{ PedidosEndereco[0].pdcTipo }} {{ PedidosEndereco[0].pdcResidencialTipo }}</small></template><span v-else>Endereço não informado.</span></article>
                                        <article class="gp-vigente-products"><header><v-icon size="17">mdi-shield-home-outline</v-icon><strong>Produtos e garantia</strong></header><div v-for="produto in ListaPedidoItem" :key="`resumo-${produto.pdiId}`" class="gp-vigente-product-row"><div><strong>{{ produto.pdiNomeProduto }}</strong><span>Código {{ produto.proId }}</span></div><div class="gp-vigente-product-config"><span><small>Cobertura</small><strong>{{ CoberturaProduto(produto) }}</strong></span><span><small>Setup</small><strong>R$ {{ formatarValor(produto.pdiCampoExtra1) }}</strong></span><span v-if="User.tpeid != 3"><small>Taxa</small><strong>{{ formatarTaxa(produto.pdiCampoExtra2) }}</strong></span></div></div><div v-if="ListaPedidoItemAdicional.length" class="gp-vigente-additionals"><span v-for="sub in ListaPedidoItemAdicional" :key="sub.piaId">+ {{ sub.piaNomeProduto }} · R$ {{ formatarValor(sub.piaValorTotalProduto) }}</span></div></article>
                                    </div>
                                    <div class="gp-vigente-progress" aria-label="Etapas concluídas da contratação">
                                        <div v-for="(etapa, index) in EtapasVigente" :key="etapa.nome" :class="['gp-vigente-progress-step', index === EtapasVigente.length - 1 ? 'is-current' : 'is-done']"><span><v-icon v-if="index < EtapasVigente.length - 1" size="14">mdi-check</v-icon><template v-else>{{ index + 1 }}</template></span><div><strong>{{ etapa.nome }}</strong><small>{{ etapa.descricao }}</small></div></div>
                                    </div>
                                    <div class="gp-vigente-section-nav">
                                        <button v-if="User.tpeid != 3" type="button" :class="{ 'is-active': secaoVigente === 'analise' }" @click="AbrirSecaoVigente('analise')"><v-icon size="16">mdi-account-search-outline</v-icon>Análise</button>
                                        <button type="button" :class="{ 'is-active': secaoVigente === 'observacoes' }" @click="AbrirSecaoVigente('observacoes')"><v-icon size="16">mdi-message-text-outline</v-icon>Observações</button>
                                        <button v-if="ListDocumentosAss?.length" type="button" :class="{ 'is-active': secaoVigente === 'contrato' }" @click="AbrirSecaoVigente('contrato')"><v-icon size="16">mdi-file-document-outline</v-icon>Contrato</button>
                                        <button type="button" :class="{ 'is-active': secaoVigente === 'pagamento' }" @click="AbrirSecaoVigente('pagamento')"><v-icon size="16">mdi-credit-card-outline</v-icon>Pagamento</button>
                                        <button type="button" :class="{ 'is-active': secaoVigente === 'documentos' }" @click="AbrirSecaoVigente('documentos')"><v-icon size="16">mdi-folder-outline</v-icon>Documentos</button>
                                        <button v-if="ListaDocs.length" type="button" :class="{ 'is-active': secaoVigente === 'docs' }" @click="AbrirSecaoVigente('docs')"><v-icon size="16">mdi-file-account-outline</v-icon>Documentos do cliente</button>
                                    </div>
                                </section>
                                <v-tabs v-model="tab" class="gp-client-tabs gp-vigente-legacy-tabs" color="#102a5a" show-arrows>
                                <v-tab value="dados" class="tabinfo"><v-icon size="16">mdi-file-document-outline</v-icon> Detalhe da contratação</v-tab>
                                <v-tab v-if="ListDocumentosAss?.length" value="contrato" class="tabinfo"><v-icon size="16">mdi-file-document-outline</v-icon> Contrato</v-tab>
                                <v-tab v-if="PedidosCli.pspId == 3" value="documentos" class="tabinfo"><v-icon size="16">mdi-folder-outline</v-icon> Documentos</v-tab>
                                 <v-tab v-if="ListaDocs.length > 0" value="docs" class="tabinfo"><v-icon size="16">mdi-file-account-outline</v-icon> Documentos do cliente</v-tab>
                                 <v-tab v-if="ListaConsultas.length > 0 && User.tpeid != 3" value="consulta" class="tabinfo"><v-icon size="16">mdi-magnify</v-icon> Consultas de crédito</v-tab>
                                </v-tabs>
                                <v-window v-model="tab">
                                    <v-window-item value="dados">
                                        <v-form>
                                            <v-container v-if="PedidosCli != '' && PedidosEndereco != ''">
                                                <v-row class="gp-vigente-legacy-summary">
                                                    <v-col cols="12" md="5">
                                                        <v-row>
                                                            <v-col cols="12" md="12">
                                                                <v-card style="padding: 15px;" color="#f7f7f7">
                                                                    <div>
                                                                        <h5 class="subtitulo" style="padding-bottom: 15px;">Endereço Contratação
                                                                        </h5>
                                                                        <p class="texto-mensagem mb-0" style="color:#333333;font-size: 14px;">
                                                                            <strong>Endereço:</strong> {{
                                                                                            PedidosEndereco[0].pdcEndereco
                                                                                        }}, {{ PedidosEndereco[0].pdcNumero }} - {{
                                                                                            PedidosEndereco[0].pdcComplemento }}
                                                                        </p>
                                                                        <p class="texto-mensagem mb-0" style="color:#333333;font-size: 14px;">
                                                                            <strong>Cidade/UF:</strong> {{
                                                                                                    PedidosEndereco[0].pdcCidade }} /
                                                                            {{ PedidosEndereco[0].pdcEstado }}
                                                                        </p>
                                                                        <p class="texto-mensagem mb-0" style="color:#333333;font-size: 14px;">
                                                                            <strong>Bairro:</strong> {{ PedidosEndereco[0].pdcBairro
                                                                            }}
                                                                        </p>
                                                                        <p class="texto-mensagem mb-0" style="color:#333333;font-size: 14px;">
                                                                            <strong>CEP:</strong> {{ PedidosEndereco[0].pdcCep }}
                                                                        </p>
                                                                        <p class="texto-mensagem mb-0" style="color:#333333;font-size: 14px;">
                                                                            <strong>Tipo Imóvel:</strong> {{ PedidosEndereco[0].pdcTipo
                                                                            }} {{ PedidosEndereco[0].pdcResidencialTipo }}
                                                                        </p>
                                                                    </div>
                                                                </v-card>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                    <v-col cols="12" md="7">
                                                        <v-row>
                                                            <v-col cols="12" md="12">
                                                                <v-card style="padding: 15px;min-height: 215px;" color="#f7f7f7">
                                                                    <div>
                                                                        <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                            Informações Contratação</h5>
                                                                        <h6 class="mb-0"><strong>Contratação: {{ PedidosCli.pedId }}</strong></h6>
                                                                        <div class="pedido_dados" v-if="PedidosCli.pedCiclo > 1"><strong>Renovação:  {{ PedidosCli.pedCodigoContratacao }} - Ciclo: {{ PedidosCli.pedCiclo }}</strong></div>
                                                                        <div class="pedido_dados"><strong>Garantidora:</strong> {{ DadosGarantidora.garNomeEmpresa }}</div>
                                                                        <div class="pedido_dados"><strong>Imobiliária:</strong> {{ Imobiliaria.imoNomeEmpresa }} - {{ Imobiliaria.imoEmail }} <v-icon @click="openDialogImobiliaria(Imobiliaria.imoId)">mdi-folder-open</v-icon> </div>
                                                                        <div class="pedido_dados"><strong>Cliente:</strong> {{ Cliente.cliNomeEmpresa }} - {{ Cliente.cliEmail }}  <v-icon @click="openDialogCliente(Cliente.cliId)">mdi-folder-open</v-icon></div>
                                                                        <div class="pedido_dados"><strong>Data :</strong> {{ formattedDate(PedidosCli.pedDataPedido) }}</div>
                                                                          <div class="pedido_dados"
                                                                            v-if="ListDocumentosAss != null && ListDocumentosAss.length > 0">
                                                                            <div v-if="ListDocumentosAss[0].pftUrlDocAssinado != '' && ListDocumentosAss[0].pftUrlDocAssinado != null">
                                                                                <strong>Contrato Assinado:</strong> 
                                                                                <a @click.prevent="VisualizarDocumento(ListDocumentosAss[0].pftUrlDocAssinado)" style="cursor: pointer;">
                                                                                    Clique para visualizar
                                                                                </a>
                                                                            </div>
                                                                            <div v-if="EhAssinaturaFisica" class="gp-physical-contract-upload">
                                                                                <input ref="arquivoContratoAssinado" type="file" accept="application/pdf" hidden @change="UploadContratoAssinadoFisico" />
                                                                                <button type="button" class="btn btn-outline-primary" :disabled="salvandoContratoAssinado" @click="$refs.arquivoContratoAssinado.click()">
                                                                                    <v-icon size="16">mdi-file-upload-outline</v-icon>
                                                                                    {{ ListDocumentosAss[0].pftUrlDocAssinado ? 'Substituir contrato assinado' : 'Anexar contrato assinado' }}
                                                                                </button>
                                                                            </div>
                                                                              <div v-if="ListDocumentosAss[0].pftUrlImagem != '' && ListDocumentosAss[0].pftUrlImagem != null">
                                                                                <strong>Contrato Original:</strong> 
                                                                                <a @click.prevent="VisualizarDocumento(ListDocumentosAss[0].pftUrlImagem)" style="cursor: pointer;">
                                                                                    Clique para visualizar
                                                                                </a>
                                                                            </div>
                                                                            <div class="pedido_dados" style="padding-top: 20px;" v-if="User.garid == 0 && PedidosCli.pspId == 3">
                                                                                <button type="button" class="btn btn-black" :disabled="reprocessandoContrato"
                                                                                    style="color:#ffffff;margin: 5px;padding:10px;"
                                                                                    @click="ReprocessarContrato(ListDocumentosAss)">
                                                                                    <v-icon size="16">mdi-file-refresh-outline</v-icon> {{ reprocessandoContrato ? 'Reprocessando...' : 'Reprocessar contrato' }}
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        <div class="pedido_dados" v-if="PedidosCli.pedFormaPgto!=''">
                                                                            <strong>Forma de Pgto:</strong> {{
                                                                            PedidosCli.pedFormaPgto }}
                                                                            
                                                                        </div>
                                                                        <div class="pedido_dados" style="display: inline-flex;" v-if="PedidosCli.pedSetupEntrada!=null && (PedidosCli.pedTipoPgto == 3 || PedidosCli.pedTipoPgto == 4)">
                                                                            <strong>Parcelamento:</strong> 
                                                                            <div v-if="PedidosCli.pedSetupEntrada == 1">R$ {{ formatarValor(PedidosCli.pedValorEntrada) }} + {{ PedidosCli.pedQtdeParcelas }}x de R$ {{ formatarValor(PedidosCli.pedValorParcelas) }}</div>
                                                                            <div v-if="PedidosCli.pedSetupEntrada == 0">{{ PedidosCli.pedQtdeParcelas }}x de R$ {{ formatarValor(PedidosCli.pedValorParcelas) }}</div>
                                                                        </div>
                                                                    </div>
                                                                </v-card>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                                <v-row class="gp-vigente-legacy-products">
                                                    <v-col cols="12" md="12">
                                                        <v-row>
                                                            <v-col cols="12" md="12">
                                                                <v-card style="padding: 25px;" color="#f9f9f9">
                                                                    <div>
                                                                        <h5 class="subtitulo" style="padding-bottom: 15px;">Produto</h5>
                                                                        <div v-for="produto in ListaPedidoItem" :key="produto.pdiId"
                                                                            class="descricao-pedido border-top py-3">
                                                                            <div class="row">
                                                                                <div v-if="ListaProdutosImg!=''"
                                                                                    class="col-3 col-md-2 d-flex align-items-center justify-content-center">
                                                                                    <div class="descricao-img">
                                                                                        <img  v-if="ListaProdutosImg.filter(x=> x.proId === produto.proId) != ''" :src="buildFileUrl(ListaProdutosImg.filter(x=> x.proId == produto.proId)[0].pimUrlImagem)"  class="img-fluid border border-rounded mb-3 mb-md-0"/>
                                                                                        <img v-else class="img-fluid border border-rounded mb-3 mb-md-0"
                                                                                            src="/imagens/indisponivel.jpg"
                                                                                            alt="">
                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    class="col-6 col-md-5 d-flex align-items-center">
                                                                                    <div class="descricao-content">
                                                                                        <h6 class="subtitulo" >{{produto.pdiNomeProduto}}</h6>
                                                                                        <p class="texto-mensagem" style="margin: 0 0 0px"> Código: {{produto.proId }}</p>
                                                                                        <p class="texto-mensagem" style="margin: 0 0 0px; display: inline-flex;"> 
                                                                                            <v-text-field v-model="produto.pdiDataVigenciaIni" type="date" disabled label="Data Vigência Inicial:" variant="underlined" style="padding-right: 15px;"></v-text-field>
                                                                                            <v-text-field v-model="produto.pdiDataVigenciaFim" type="date" disabled label="Data Vigência Final:" variant="underlined"></v-text-field> 
                                                                                        </p>
                                                                                        <p class="texto-mensagem" style="margin: 0 0 0px"> Setup: R$ {{ formatarValor(produto.pdiCampoExtra1) }}</p>
                                                                                        <p class="texto-mensagem" style="margin: 0 0 0px" v-if="User.tpeid != 3"> Taxa: {{ formatarTaxa(produto.pdiCampoExtra2) }}</p>
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-6 col-md-3 d-flex align-items-center">
                                                                                    <ul>
                                                                                        <li v-for="(sub,index) in ListaPedidoItemAdicional" :key="index" style="font-size: 12px;"> 
                                                                                        {{ sub.piaNomeProduto }} - R$ {{ formatarValor(sub.piaValorTotalProduto) }}
                                                                                        </li>
                                                                                    </ul>
                                                                                </div>
                                                                                <div
                                                                                    class="col-6 col-md-2 d-flex align-items-center">
                                                                                    <div class="descricao-content">
                                                                                        <h6 class="subtitulo"
                                                                                            style="font-size: 15px;">
                                                                                            R$ {{
                                                                                            parseFloat(produto.pdiValorTotalProduto).toFixed(2).toString().replace('.',
                                                                                            ',')
                                                                                            }}</h6>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </v-card>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col cols="12" md="12">
                                                                <v-card style="padding: 25px;" color="#f7f7f7">
                                                                    <div>
                                                                        <div
                                                                            class="d-flex align-items-center justify-content-between">
                                                                            <h5 class="subtitulo">Total</h5>
                                                                            <h6 class="subtitulo">R$ {{
                                                                                parseFloat(TotalPedido).toFixed(2).toString().replace('.',
                                                                                ',')
                                                                                }}</h6>
                                                                        </div>
                                                                    </div>
                                                                </v-card>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-if="User.tpeid != 3" v-show="secaoVigente === 'analise'">
                                                    <v-col cols="12" md="3" style="text-align:center;" v-for="itemAnalise in analisesCredito" :key="itemAnalise.titulo">
                                                        <v-card style="padding: 25px;margin-top: 30px;" color="#f7f7f7">
                                                            <h5 class="subtitulo" style="padding-bottom: 15px;">{{ itemAnalise.titulo }}</h5>
                                                            <div style="min-height: 50px;">
                                                                <div>{{ itemAnalise.nome || 'Não Cadastrado' }}</div>
                                                                <div>{{ itemAnalise.documento }}</div>
                                                            </div>
                                                            <v-row style="padding-top: 25px;justify-content: center;">
                                                                <VueSpeedometer :value="getScoreConsulta(itemAnalise.consultas)" :minValue="0" :maxValue="1000" segments="5" :width="200" :height="180" needleColor="steelblue" />
                                                            </v-row>
                                                            <button type="button" class="btn btn-info" v-if="getConsulta(itemAnalise.consultas, 'ser')?.retorno && !isRetornoCpfNotAvailable(getConsulta(itemAnalise.consultas, 'ser'))" @click="CarregaModalSerasaCredito(getConsulta(itemAnalise.consultas, 'ser').retorno)" style="color:#ffffff;margin:5px;padding:10px;">Análise Crédito</button>
                                                            <div v-else-if="getConsulta(itemAnalise.consultas, 'ser')?.retorno && isRetornoCpfNotAvailable(getConsulta(itemAnalise.consultas, 'ser'))" class="text-danger" style="padding:10px;margin:5px;">CPF NAO DISPONIVEL</div>
                                                            <button type="button" class="btn btn-info" v-if="!getConsulta(itemAnalise.consultas, 'ser')?.retorno && getConsulta(itemAnalise.consultas, 'cdl')?.retorno && !isRetornoCpfNotAvailable(getConsulta(itemAnalise.consultas, 'cdl'))" @click="CarregaModalSerasaCredito2(getConsulta(itemAnalise.consultas, 'cdl').retorno)" style="color:#ffffff;margin:5px;padding:10px;">Análise Crédito</button>
                                                            <button type="button" class="btn btn-info" v-if="getConsulta(itemAnalise.consultas, 'cdl')?.retorno && !isRetornoCpfNotAvailable(getConsulta(itemAnalise.consultas, 'cdl'))" @click="CarregaModalCdlCredito(getConsulta(itemAnalise.consultas, 'cdl').retorno)" style="color:#ffffff;margin:5px;padding:10px;">Complementar</button>
                                                            <div v-else-if="getConsulta(itemAnalise.consultas, 'cdl')?.retorno && isRetornoCpfNotAvailable(getConsulta(itemAnalise.consultas, 'cdl'))" class="text-danger" style="padding:10px;margin:5px;">CPF NAO DISPONIVEL</div>
                                                            <button type="button" class="btn btn-info" v-if="getConsulta(itemAnalise.consultas, 'jus')?.retorno && !isRetornoCpfNotAvailable(getConsulta(itemAnalise.consultas, 'jus'))" @click="CarregaModalJusCredito(getConsulta(itemAnalise.consultas, 'jus').retorno)" style="color:#ffffff;margin:5px;padding:10px;">Análise Jurídica</button>
                                                            <div style="padding-top: 10px;text-align:left;">
                                                                {{ getObsConsulta(itemAnalise.consultas, 'ser', 'Crédito') }}<br/>
                                                                {{ getObsConsulta(itemAnalise.consultas, 'jus', 'Jurídica') }}<br/>
                                                                {{ getObsConsulta(itemAnalise.consultas, 'cdl', 'Complementar') }}
                                                            </div>
                                                        </v-card>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-show="secaoVigente === 'observacoes'">
                                                    <v-col cols="12" md="12">
                                                        <v-card style="padding: 25px;margin-top: 30px;" color="#f7f7f7">
                                                            <div>
                                                                <h5 class="subtitulo" style="padding-bottom: 15px;">Situação Atual: {{ PedidosCli.pedSituacaoPedido }}
                                                                </h5>
                                                                <v-row v-if="User.tpeid != 3" style="padding-top: 20px">
                                                                    <label>Observações Internas</label>
                                                                    <textarea disabled cols="12" rows="5"  class="form-control" v-model="PedidosCli.pedObsLoja" label="Observações"></textarea>
                                                                </v-row>
                                                                <v-row style="padding-top: 20px">
                                                                    <label>Observações</label>
                                                                    <textarea disabled cols="12" rows="5"  class="form-control" v-model="PedidosCli.pedObsAnalise" label="Observações"></textarea>
                                                                </v-row>
                                                                <v-row style="padding-top: 20px">
                                                                    <label>Observações Cliente</label>
                                                                    <textarea disabled cols="12" rows="5"  class="form-control" v-model="PedidosCli.pedObsCliente" label="Observações Cliente"></textarea>
                                                                </v-row>
                                                            </div>
                                                        </v-card>
                                                    </v-col>
                                                </v-row>
                                                  <v-row class="gp-vigente-legacy-cancel"
                                                    style="justify-content: center;padding-top: 15px;">
                                                    <button type="button" class="btn btn-black" v-if="PedidosCli.pspId == 3"
                                                        style="color:#ffffff;margin: 5px;padding:10px;"
                                                        @click="CancelarVigencia()">
                                                        <v-icon size="16">mdi-cancel</v-icon> Cancelar contratação vigente
                                                    </button>
                                                </v-row>
                                            </v-container>
                                        </v-form>
                                    </v-window-item>
                                    <v-window-item value="contrato">
                                        <v-container v-if="ListDocumentosAss?.length" class="gp-vigente-contract-panel">
                                            <section>
                                                <header><span><v-icon size="18">mdi-file-document-outline</v-icon><strong>Contrato vigente</strong></span><span :class="['gp-vigente-contract-status', EhAssinaturaFisica ? 'is-physical' : '']"><v-icon size="15">{{ EhAssinaturaFisica ? 'mdi-file-check-outline' : 'mdi-check-decagram-outline' }}</v-icon>{{ EhAssinaturaFisica ? 'Assinado fisicamente' : 'Contrato ativo' }}</span></header>
                                                <div class="gp-vigente-contract-document"><span><v-icon size="22">mdi-file-pdf-box</v-icon></span><div><small>Documento</small><strong>Contrato da contratação {{ PedidosCli.pedId }}</strong></div><button v-if="ListDocumentosAss[0].pftUrlImagem" type="button" @click="VisualizarDocumento(ListDocumentosAss[0].pftUrlImagem)"><v-icon size="16">mdi-file-eye-outline</v-icon>Visualizar original</button><button v-if="ListDocumentosAss[0].pftUrlDocAssinado" type="button" @click="VisualizarDocumento(ListDocumentosAss[0].pftUrlDocAssinado)"><v-icon size="16">mdi-file-check-outline</v-icon>Visualizar assinado</button></div>
                                                <footer v-if="EhAssinaturaFisica"><input ref="arquivoContratoAssinadoPainel" type="file" accept="application/pdf" hidden @change="UploadContratoAssinadoFisico" /><button type="button" :disabled="salvandoContratoAssinado" @click="$refs.arquivoContratoAssinadoPainel.click()"><v-icon size="16">mdi-file-upload-outline</v-icon>{{ ListDocumentosAss[0].pftUrlDocAssinado ? 'Substituir contrato assinado' : 'Anexar contrato assinado' }}</button><small>O arquivo PDF é opcional e pode ser anexado ou substituído posteriormente.</small></footer>
                                            </section>
                                        </v-container>
                                    </v-window-item>
                                    <v-window-item value="pagamento">
                                        <v-container class="gp-vigente-payment-wrap">
                                            <section class="gp-vigente-payment-panel">
                                                <header><span><v-icon size="19">mdi-credit-card-outline</v-icon></span><div><strong>Pagamento da contratação</strong><small>Condição de pagamento gravada para esta contratação vigente.</small></div><em><v-icon size="14">mdi-lock-outline</v-icon>Somente visualização</em></header>
                                                <div v-if="EhPagamentoPorLinkVigente" class="gp-vigente-payment-summary is-link"><article><small>Valor da cobrança</small><strong>R$ {{ formatarValor(ValorTotalPagamentoVigente) }}</strong><span>Pagamento em valor único</span></article><article><small>Forma de pagamento</small><strong>Link de pagamento</strong><span>Condição confirmada</span></article></div>
                                                <div v-else class="gp-vigente-payment-summary"><article><small>Entrada</small><strong>{{ Number(PedidosCli.pedValorEntrada || 0) > 0 ? `R$ ${formatarValor(PedidosCli.pedValorEntrada)}` : 'Sem entrada' }}</strong><span>{{ PedidosCli.pedFormaPgtoEntrada || PedidosCli.pedFormaPgtoParcelas || PedidosCli.pedFormaPgto || '—' }}</span></article><article><small>Saldo parcelado</small><strong>{{ PedidosCli.pedQtdeParcelas || 0 }}x de R$ {{ formatarValor(PedidosCli.pedValorParcelas || 0) }}</strong><span>{{ PedidosCli.pedFormaPgtoParcelas || PedidosCli.pedFormaPgto || '—' }}</span></article><article><small>Setup</small><strong>{{ ValorSetupVigente > 0 ? `R$ ${formatarValor(ValorSetupVigente)}` : 'Sem setup' }}</strong><span>{{ ValorSetupVigente > 0 ? (Number(PedidosCli.pedSetupEntrada) === 1 ? 'Incluído na entrada' : 'Distribuído no saldo') : 'Não se aplica' }}</span></article></div>
                                            </section>
                                        </v-container>
                                    </v-window-item>
                                    <v-window-item value="documentos" >
                                        <v-container class="gp-vigente-documents-wrap">
                                            <section class="gp-vigente-documents-panel">
                                                <header><span><v-icon size="19">mdi-folder-upload-outline</v-icon></span><div><strong>Documentos da contratação</strong><small>Anexe arquivos complementares à contratação vigente.</small></div><em>{{ ListDocumentos.length }} arquivo(s)</em></header>
                                                <div class="gp-vigente-document-upload">
                                                    <label><span>Nome do documento</span><input v-model="nomeDocumento" type="text" class="form-control" placeholder="Ex.: Comprovante atualizado" /></label>
                                                    <label class="gp-vigente-file-field"><span>Arquivo</span><v-file-input v-model="selectedFile" label="JPG, JPEG, PNG ou PDF" variant="outlined" density="compact" hide-details prepend-inner-icon="mdi-paperclip" prepend-icon="" accept="image/*,application/pdf"></v-file-input></label>
                                                    <button type="button" class="btn" @click.prevent="EnviarDocumento()"><v-icon size="16">mdi-upload</v-icon>Enviar documento</button>
                                                </div>
                                                <div v-if="ListDocumentos.length" class="gp-vigente-document-list">
                                                    <div v-for="item in ListDocumentos" :key="item.pmsId" class="gp-vigente-document-item"><span><v-icon size="18">mdi-file-document-outline</v-icon></span><div><strong>{{ item.pmsNome }}</strong><small>Documento complementar</small></div><button v-if="item.pmsUrlImagem" type="button" title="Visualizar documento" @click.prevent="VisualizarDocumento(item.pmsUrlImagem)"><v-icon size="16">mdi-file-eye-outline</v-icon>Visualizar</button></div>
                                                </div>
                                                <div v-else class="gp-vigente-document-empty"><v-icon size="27">mdi-file-document-plus-outline</v-icon><strong>Nenhum documento anexado</strong><span>Os arquivos enviados serão exibidos aqui.</span></div>
                                            </section>
                                        </v-container>
                                    </v-window-item>
                                     <!--Docs-->
                                    <v-window-item value="docs">
                                        <div style="padding-top: 20px;padding-bottom: 10px;padding-left: 20px;">
                                           Documentos inseridos no cadastro do cliente </div>
                                        <v-form>
                                                <v-container>
                                                    <v-row>
                                                        <v-table>
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-left">
                                                                        Documento
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Cadastro
                                                                    </th>
                                                                    <th class="text-left">
                                                                        Visualização
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="item in ListaDocs" :key="item.cdsId">
                                                                    <td>{{ item.cdsNomeDoc }}</td>
                                                                    <td>{{ formattedDate(item.cdsDataCadastro) }}</td>
                                                                    <td style="text-align: center;">
                                                                        <v-btn v-if="item.cdsUrlDoc != ''" icon
                                                                            @click.prevent="VisualizarDocumento(item.cdsUrlDoc)"
                                                                            variant="text">
                                                                            <v-icon>mdi-file-eye</v-icon>
                                                                            <v-tooltip activator="parent"
                                                                                location="top">Visualizar</v-tooltip>
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </v-table>
                                                    </v-row>
                                                </v-container>
                                            </v-form>
                                    </v-window-item>
                                    <!--Docs-->
                                     <!--consultas-->
                                    <v-window-item value="consulta">
                                        <div style="padding-top: 20px;padding-bottom: 10px;padding-left: 20px;">
                                            Consultas feitas no cadastro do cliente </div>
                                        <v-form>
                                            <v-container>
                                                <v-row>
                                                    <v-table>
                                                        <thead>
                                                            <tr>
                                                                <th class="text-left">
                                                                    Nome
                                                                </th>
                                                                <th class="text-left">
                                                                    Tipo
                                                                </th>
                                                                <th class="text-left">
                                                                    Cadastro
                                                                </th>
                                                                <th class="text-left">
                                                                    Score
                                                                </th>
                                                                <th class="text-left">
                                                                    Visualizações
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="item in ListaConsultas" :key="item.ccsId">
                                                                <td>{{ item.cliNome }}</td>
                                                                <td>{{ item.cliTipo }}</td>
                                                                <td>{{ formattedDate(item.ccsDataConsulta) }}</td>
                                                                <td>{{ item.ccsScore }}</td>
                                                                <td>
                                                                    <button type="button" class="btn btn-info"
                                                                        @click="CarregaModalSerasa(item)"
                                                                        style="color:#ffffff;margin:5px;padding:10px;">
                                                                        Crédito
                                                                    </button>
                                                                    <button type="button" class="btn btn-info"
                                                                        @click="CarregaModalJus(item)"
                                                                        style="color:#ffffff;margin:5px;padding:10px;">
                                                                        Jurídica
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </v-table>
                                                </v-row>
                                            </v-container>
                                        </v-form>

                                    </v-window-item>
                                    <!--consultas-->
                                </v-window>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    <!--modal Cliente-->
    <v-row justify="center">
        <v-dialog v-model="dialogCliente" class="controlcelEnd gp-active-detail-dialog" transition="dialog-bottom-transition"
          width="auto">
            <v-card>
                <v-card-title style="background-color: #cccccc;">
                <span class="text-h5" style="font-size: 19px !important;" >Informações do Cliente</span>
                </v-card-title>
                <v-card-text style="padding: 16px 0px 10px">
                    <v-form>
                        <v-container>
                            <v-row>
                                <v-col v-if="Cliente!=''"  cols="12" md="6" style="border-right: 1px solid #cccccc;">
                                    <v-row> 
                                        <v-col cols="12" md="3">
                                            <span style="font-weight: 500;">Nome: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                            <span>{{ Cliente.cliNomeEmpresa }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">CPF/CNPJ: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliDocumento  }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3" v-if="Cliente.tpdId == 2">
                                             <span style="font-weight: 500;">Razão Social: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;" v-if="Cliente.tpdId == 2">
                                             <span>{{ Cliente.cliRazaoSocial  }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3" v-if="Cliente.tpdId == 2">
                                             <span style="font-weight: 500;">Responsável: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;" v-if="Cliente.tpdId == 2">
                                             <span>{{ Cliente.cliResponsavel  }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3" v-if="Cliente.tpdId == 2">
                                             <span style="font-weight: 500;">CPF: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;" v-if="Cliente.tpdId == 2">
                                             <span>{{ Cliente.cliCampoExtra1  }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <span style="font-weight: 500;">Telefone: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliTelefone }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Whatsapp: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliWhatsapp }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">E-mail: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliEmail }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Nascimento: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ formattedDate(Cliente.cliDataNascimento) }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Estado Civil: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliEstadoCivil }}</span>
                                        </v-col>
                                       
                                    </v-row>
                                </v-col>
                                <v-col v-if="Endereco!=''"  cols="12" md="6">
                                    <v-row>
                                        <v-col cols="12" md="12">
                                            <span style="font-weight: 500;">Endereço Alternativo: </span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Endereço: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Endereco.cleEndereco }} - {{ Endereco.cleNumero }} - {{  Endereco.cleComplemento }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Cidade/UF: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Endereco.cleCidade }} / {{ Endereco.cleEstado }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Bairro: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Endereco.cleBairro }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">CEP: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Endereco.cleCep }}</span>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col v-if="Cliente!='' && Cliente!=null && Cliente.cliCpfConjuge &&  Cliente.cliCpfConjuge != '' && Cliente.cliCpfConjuge != null"  cols="12" md="6" style="border-right: 1px solid #cccccc;">
                                    <v-row> 
                                        <v-col cols="12" md="3">
                                            <span style="font-weight: 500;">Conjuge: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                            <span>{{ Cliente.cliNomeConjuge }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">CPF: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliCpfConjuge  }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <span style="font-weight: 500;">Telefone: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliTelefoneConjuge }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Whatsapp: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliWhatsappConjuge }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">E-mail: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliEmailConjuge }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Data Nascimento: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ formattedDate(Cliente.cliDataNascimentoConjuge)}}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Endereço: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span v-html="Cliente.cliTexto1"></span>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col v-if="Cliente!='' && Cliente!=null && Cliente.cliCpfCorresponsavel &&  Cliente.cliCpfCorresponsavel != '' && Cliente.cliCpfCorresponsavel != null"  cols="12" md="6" style="border-right: 1px solid #cccccc;">
                                    <v-row> 
                                        <v-col cols="12" md="3">
                                            <span style="font-weight: 500;">Corresponsável: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                            <span>{{ Cliente.cliNomeCorresponsavel }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">CPF: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliCpfCorresponsavel  }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <span style="font-weight: 500;">Telefone: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliTelefoneCorresponsavel }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Whatsapp: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliWhatsappCorresponsavel }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">E-mail: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliEmailCorresponsavel }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Data Nascimento: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ formattedDate(Cliente.cliDataNascimentoCorresponsavel)}}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Estado Civil: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliEstadoCivilCorresponsavel }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Nome Pai: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliNomePaiCorresponsavel }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Nome Mãe: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Cliente.cliNomeMaeCorresponsavel }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Endereço: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span v-html="Cliente.cliTexto2"></span>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                     <v-btn @click.prevent="dialogCliente=false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>

     <!--modal imobiliaria-->
     <v-row justify="center">
        <v-dialog v-model="dialogImobiliaria" class="controlcelEnd gp-active-detail-dialog" transition="dialog-bottom-transition"
          width="auto">
            <v-card>
                <v-card-title style="background-color: #cccccc;">
                <span class="text-h5" style="font-size: 19px !important;">Informações do Imobiliária</span>
                </v-card-title>
                <v-card-text style="padding: 16px 0px 10px">
                    <v-form>
                        <v-container>
                            <v-row>
                                <v-col v-if="Imobiliaria!=''" cols="12" md="6" style="border-right: 1px solid #cccccc;">
                                    <v-row>
                                        <v-col cols="12" md="3">
                                            <span style="font-weight: 500;">Nome: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                            <span>{{ Imobiliaria.imoNomeEmpresa }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">CPF/CNPJ: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Imobiliaria.imoDocumento  }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3"  v-if="Imobiliaria.tpdId == 2">
                                             <span style="font-weight: 500;">Razão Social: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;" v-if="Imobiliaria.tpdId == 2">
                                             <span>{{ Imobiliaria.imoRazaoSocial  }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3"  v-if="Imobiliaria.tpdId == 2">
                                             <span style="font-weight: 500;">Responsável: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;" v-if="Imobiliaria.tpdId == 2">
                                             <span>{{ Imobiliaria.imoResponsavel  }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3"  v-if="Imobiliaria.tpdId == 2">
                                             <span style="font-weight: 500;">CPF: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;" v-if="Imobiliaria.tpdId == 2">
                                             <span>{{ Imobiliaria.imoCampoExtra1  }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <span style="font-weight: 500;">Telefone: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Imobiliaria.imoTelefone }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Whatsapp: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Imobiliaria.imoWhatsapp }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">E-mail: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ Imobiliaria.imoEmail }}</span>
                                        </v-col>
                                       
                                    </v-row>
                                </v-col>
                                <v-col v-if="EnderecoImob!=''" cols="12" md="6">
                                    <v-row>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Endereço: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ EnderecoImob.imeEndereco }} - {{ EnderecoImob.imeNumero }} - {{  EnderecoImob.imeComplemento }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Cidade/UF: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ EnderecoImob.imeCidade }} / {{ EnderecoImob.imeEstado }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">Bairro: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ EnderecoImob.imeBairro }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                             <span style="font-weight: 500;">CEP: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;">
                                             <span>{{ EnderecoImob.imeCep }}</span>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                     <v-btn @click.prevent="dialogImobiliaria=false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>

        <v-row justify="center">
            <v-dialog v-model="dialogSerasa" class="controlcelEnd gp-active-detail-dialog" transition="dialog-bottom-transition" width="auto">
                <v-card ref="serasaContent">
                    <v-card-title style="background-color: #cccccc;">
                        <span class="text-h5" style="font-size: 19px !important;">Análise de Crédito</span>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px" v-if="ListaSerasa != '' && ListaSerasa != null && ListaSerasa.reports && ListaSerasa.reports.length > 0">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12" style="border-right: 1px solid #cccccc;">
                                       <v-row v-if="ListaSerasa.reports[0].reportName == 'RELATORIO_BASICO_PF_PME'">
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].reportName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.score }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Probabilidade de Inadimplência: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.defaultRate }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Situação Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.statusRegistration
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cliente:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.consumerName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Nome da mãe: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.motherName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Data Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ formattedDate(ListaSerasa.reports[0].registration.birthDate)
                                                    }}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else-if="ListaSerasa.reports[0].reportName == 'RELATORIO_BASICO_PJ_PME'">
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].reportName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.score }}</span>
                                                <span>{{ ListaSerasa.reports[0].score.message }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Probabilidade de Inadimplência: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ (ListaSerasa.reports[0].score.defaultRate / 100) }} %</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Situação Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.statusRegistration
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Documento:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.companyDocument }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cliente:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.companyName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Fundação: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    formattedDate(ListaSerasa.reports[0].registration.foundationDate)
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cidade: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.address.city }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Estado: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.address.state }}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else-if="ListaSerasa.reports[0].reportName == 'RELATORIO_AVANCADO_TOP_SCORE_PF_PME'">
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].reportName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.score }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Probabilidade de Inadimplência: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.defaultRate }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Situação Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.statusRegistration
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cliente:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.consumerName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Nome da mãe: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.motherName }}</span>
                                            </v-col>
                                               <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Estado Civil: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.maritalStatusDescription }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Data Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ formattedDate(ListaSerasa.reports[0].registration.birthDate)
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Ocupação: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].registration.occupation
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Endereço: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].addresses }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;" v-if="ListaSerasa.reports[0].phones && ListaSerasa.reports[0].phones.length > 0">
                                                <span style="font-weight: 500;">Fone 1: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;" v-if="ListaSerasa.reports[0].phones && ListaSerasa.reports[0].phones.length > 0">
                                                <span>{{ ListaSerasa.reports[0].phones[0] }}</span>
                                            </v-col>
                                             <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;" v-if="ListaSerasa.reports[0].phones && ListaSerasa.reports[0].phones.length > 1">
                                                <span style="font-weight: 500;">Fone 2: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;" v-if="ListaSerasa.reports[0].phones && ListaSerasa.reports[0].phones.length > 1">
                                                <span>{{ ListaSerasa.reports[0].phones[1] }}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else-if="ListaSerasa.reports[0].reportName == 'RELATORIO_AVANCADO_PJ_PME'">
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].reportName }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].score.score }}</span>
                                                <span>{{ ListaSerasa.reports[0].score.message }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Probabilidade de Inadimplência: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ (ListaSerasa.reports[0].score.defaultRate / 100) }} %</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Situação Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.statusRegistration
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Documento:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.documentNumber }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cliente:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.companyName }}</span>
                                            </v-col>
                                             <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Fantasia:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.companyAlias }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Fundação: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    formattedDate(ListaSerasa.reports[0].identificationReport.companyFoundation)
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Funcionários: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    ListaSerasa.reports[0].identificationReport.numberEmployees
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Tributação: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    ListaSerasa.reports[0].identificationReport.taxOption
                                                    }}</span>
                                            </v-col>
                                             <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Atividade Econômica: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    ListaSerasa.reports[0].identificationReport.economicActivity
                                                    }}</span>
                                            </v-col>
                                              <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cnae: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{
                                                    ListaSerasa.reports[0].identificationReport.cnae
                                                    }}</span>
                                            </v-col>
                                           <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;" v-if="ListaSerasa.reports[0].identificationReport">
                                                <span style="font-weight: 500;">Endereço: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;" v-if="ListaSerasa.reports[0].identificationReport">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.addresses }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;" v-if="ListaSerasa.reports[0].identificationReport.phone">
                                                <span style="font-weight: 500;">Fone: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;" v-if="ListaSerasa.reports[0].identificationReport.phone">
                                                <span>{{ ListaSerasa.reports[0].identificationReport.phone }}</span>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].negativeData &&
                                            ListaSerasa.reports[0].negativeData.pefin &&
                                            ListaSerasa.reports[0].negativeData.pefin.pefinResponse &&
                                            ListaSerasa.reports[0].negativeData.pefin.pefinResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras (PEFIN)
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(pefin, index) in ListaSerasa.reports[0].negativeData.pefin.pefinResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(pefin.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Natureza da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.legalNature }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do contrato:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.contractId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do credor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.creditorName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(pefin.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras (PEFIN)
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].negativeData &&
                                            ListaSerasa.reports[0].negativeData.refin != '' &&
                                            ListaSerasa.reports[0].negativeData.refin.refinResponse &&
                                            ListaSerasa.reports[0].negativeData.refin.refinResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Restrições Financeiras (REFIN)
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(refin, index) in ListaSerasa.reports[0].negativeData.refin.refinResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(refin.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Natureza da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ refin.legalNature }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do contrato:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ refin.contractId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do credor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ refin.creditorName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3">
                                                        <span style="font-weight: 500;">Valor da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(refin.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ refin.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Restrições Financeiras (REFIN)
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].negativeData &&
                                            ListaSerasa.reports[0].negativeData.notary &&
                                            ListaSerasa.reports[0].negativeData.notary.notaryResponse &&
                                            ListaSerasa.reports[0].negativeData.notary.notaryResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas – Protestos
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(prot, index) in ListaSerasa.reports[0].negativeData.notary.notaryResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(prot.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(prot.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Número do Cartório: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.officeNumber }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cartório: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.officeName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.city }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas – Protestos
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].negativeData &&
                                            ListaSerasa.reports[0].negativeData.check &&
                                            ListaSerasa.reports[0].negativeData.check.checkResponse &&
                                            ListaSerasa.reports[0].negativeData.check.checkResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas - Cheques Sem Fundo (CCF)
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(cheq, index) in ListaSerasa.reports[0].negativeData.check.checkResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(cheq.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do banco: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.bankId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do banco: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.bankName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Número da agência: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.bankAgencyId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Quantidade de cheques: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.checkCount }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.city }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ cheq.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas - Cheques Sem Fundo (CCF)
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaSerasa.reports[0].negativeData &&
                                                ListaSerasa.reports[0].negativeData.collectionRecords &&
                                                ListaSerasa.reports[0].negativeData.collectionRecords.collectionRecordsResponse &&
                                                ListaSerasa.reports[0].negativeData.collectionRecords.collectionRecordsResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas - Dívidas Vencidas (Convem)
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].negativeData.collectionRecords.collectionRecordsResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Natureza da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.legalNature }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do contrato:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.contractId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do credor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.creditorName }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(convem.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.city }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.federalUnit }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas - Dívidas Vencidas (Convem)
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                          <v-row
                                            v-if="ListaSerasa.reports[0].facts &&
                                                ListaSerasa.reports[0].facts.inquiry &&
                                                ListaSerasa.reports[0].facts.inquiry.inquiryResponse &&
                                                ListaSerasa.reports[0].facts.inquiry.inquiryResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Histórico de Consultas de crédito
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].facts.inquiry.inquiryResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Segmento: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.segmentDescription }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Quantidade:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.daysQuantity }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                 Histórico de Consultas de crédito
                                                 {{ ListaSerasa.reports[0].facts ? 'Existe' : 'Não existe' }}
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaSerasa.reports[0].facts &&
                                                ListaSerasa.reports[0].facts.judgementFilings &&
                                                ListaSerasa.reports[0].facts.judgementFilings.judgementFilingsResponse &&
                                                ListaSerasa.reports[0].facts.judgementFilings.judgementFilingsResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Processos em Julgamento
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].facts.judgementFilings.judgementFilingsResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                 <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Natureza: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.legalNature }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formatarValor(convem.amount) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.city }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">UF:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.state }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                 Processos em Julgamento
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaSerasa.reports[0].facts &&
                                                ListaSerasa.reports[0].facts.bankrupts &&
                                                ListaSerasa.reports[0].facts.bankrupts.bankruptsResponse &&
                                                ListaSerasa.reports[0].facts.bankrupts.bankruptsResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                               Falências Bancárias
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].facts.bankrupts.bankruptsResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                 <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Empresa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.companyName }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                 Falências Bancárias
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaSerasa.reports[0].partner &&
                                                ListaSerasa.reports[0].partner.partnershipResponse &&
                                                ListaSerasa.reports[0].partner.partnershipResponse.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                               Sociedades
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].partner.partnershipResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Empresa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.companyName }}</span>
                                                    </v-col>
                                                </v-row>
                                                 <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Participação: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.participationPercentage }}</span>
                                                    </v-col>
                                                </v-row>
                                                  <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">UF: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.companyState }}</span>
                                                    </v-col>
                                                </v-row>
                                                  <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Status: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.companyStatus }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                  Sociedades
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaSerasa.reports[0].reportName == 'RELATORIO_BASICO_PJ_PME' &&
                                            ListaSerasa.reports[0].director &&
                                            ListaSerasa.reports[0].director.DirectorResponse &&
                                            ListaSerasa.reports[0].director.DirectorResponse.results.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Administradores
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(dire, index) in ListaSerasa.reports[0].director.DirectorResponse.results"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Tipo Documento: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.documentType }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Documento: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.documentId }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.name }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cargo: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.role }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Possui restrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ dire.hasNegative ? "Sim" : "Não" }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                         <v-btn @click.prevent="exportPdf">Exportar PDF</v-btn>
                        <v-btn @click.prevent="dialogSerasa = false">Fechar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

      <!--modal JusBrasil-->
      <v-row justify="center">
        <v-dialog v-model="dialogJusBrasil" class="controlcelEnd gp-active-detail-dialog" transition="dialog-bottom-transition"
          width="auto">
            <v-card ref="jusContent">
                <v-card-title style="background-color: #cccccc;">
                <span class="text-h5" style="font-size: 19px !important;">Informações Jurídicas</span>
                </v-card-title>
                <v-card-text style="padding: 16px 0px 10px" v-if="ListaJusBrasil != '' && ListaJusBrasil != null">
                    <v-form>
                        <v-container>
                            <v-row>
                                <v-col  cols="12" md="12" style="border-right: 1px solid #cccccc;" v-if="ListaJusBrasil.processos && 
                                                 ListaJusBrasil.processos.length > 0">
                                    <v-row>
                                        <v-col cols="12" md="12">
                                           Dados Cadastrais
                                        </v-col>
                                        <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                            <span style="font-weight: 500;">Nome: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                            <span>{{ ListaJusBrasil.nome }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                            <span style="font-weight: 500;">Tipo: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                            <span>{{ ListaJusBrasil.identificacao.tipo }}</span>
                                        </v-col>
                                        <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                            <span style="font-weight: 500;">Documento: </span>
                                        </v-col>
                                        <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                            <span>{{ ListaJusBrasil.identificacao.valor }}</span>
                                        </v-col>                        
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;" >
                                            Processos
                                        </v-col>
                                        <v-col cols="12" md="12" v-for="(proc,index) in ListaJusBrasil.processos" :key="index" :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'" >
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Tipo Processo: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.tipo_processo }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Data Atualização: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.data_ultima_atualizacao }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Natureza: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.natureza }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row v-if="proc.partes.length > 0">
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Partes: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9" style="text-align: left; padding-bottom: 2px; padding-top: 3px;">
                                                        <div v-for="(parte, indexParte) in proc.partes" :key="indexParte">
                                                            <span><strong>Nome:</strong> {{ parte.nome }}</span><br>
                                                            <span><strong>Papel:</strong> {{ parte.papel }}</span>
                                                        </div>
                                                    </v-col>
                                                </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Assunto: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.assunto }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Ano Processo: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.ano_do_processo }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Tribunal: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.tribunal }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">UF: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.UF }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Comarca: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.comarca }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Fórum: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.forum }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Valor da causa: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ formatarValor(proc.valor_causa) }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Numero Processo: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.numero_processo }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Link: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.link }}</span>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                    <span style="font-weight: 500;">Status: </span>
                                                </v-col>
                                                <v-col cols="12" md="9" style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                    <span>{{ proc.status }}</span>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col v-else>
                                    <v-col v-if="ListaJusBrasil.fault" cols="12" md="12" style="background-color: #cccccc;margin-top:30px;" >
                                        {{ ListaJusBrasil.fault.faultstring }}
                                    </v-col>
                                    <v-col v-else cols="12" md="12" style="background-color: #cccccc;margin-top:30px;" >
                                        Nada Consta
                                    </v-col>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                     <v-btn @click.prevent="export2Pdf">Exportar PDF</v-btn>
                     <v-btn @click.prevent="dialogJusBrasil=false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
         <!--modal CDL 2-->
         <v-row justify="center">
            <v-dialog v-model="dialogSerasa2" class="controlcelEnd gp-active-detail-dialog" transition="dialog-bottom-transition" width="auto" >
                <v-card ref="serasaContent">
                    <v-card-title style="background-color: #cccccc;">
                        <span class="text-h5" style="font-size: 19px !important;">Análise de Crédito</span>
                        <span class="text-h5" style="font-size: 19px !important;" v-if="ConsultasCliente.filter(x=> x.tipo == 'cdl').length > 0"> - Data: {{ formattedDate(ConsultasCliente.filter(x=> x.tipo == 'cdl')[0].dtRetorno) }}</span>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px">
                        <v-form>
                            <v-container>
                                <v-row v-if="Cliente.tpdId == 1 && ListaCdl != '' && ListaCdl != null && ListaCdl.ConsultaFamiliaPositivoResponse && ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult && ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo">
                                    <v-col cols="12" md="12" style="border-right: 1px solid #cccccc;">
                                        <v-row>
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>Consulta Familia Positivo</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.score_classificacao_varios_modelos[0].score }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Status Consumidor: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.status_consumidor.mensagem }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.identificacao.documento }}</span>
                                            </v-col>
                                             <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Título eleitor: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.identificacao.tituloEleitor }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Cliente:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.identificacao.nome }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Nome da mãe: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.identificacao.nomeMae }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Data Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.identificacao.dataNascimento }}</span>
                                            </v-col>
                                             <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Obito: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.identificacao.obito }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3"
                                                style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Decisão Sugerida: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.decisao.texto }}</span>
                                            </v-col>

                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo &&
                                                     Array.isArray(ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.debitos) &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.debitos.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(pefin, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.debitos"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data Ocorrência: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.dataOcorrencia }}</span>
                                                    </v-col>
                                                </v-row>
                                                 <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data Disponibilização: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.dataDisponibilizacao }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Identificador do contrato:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.contrato }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nome do credor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.informante }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor da dívida: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.moeda }} {{ pefin.valor }}</span>
                                                    </v-col>
                                                </v-row>
                                                   <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Segmento: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.segmento }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.uf }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo &&
                                                     Array.isArray(ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.titulos_protestados) &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.titulos_protestados.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas – Protestos
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(prot, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.titulos_protestados"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.dataOcorrencia }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.moeda }} {{ prot.valor }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Número do Cartório: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.cartorio }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Cidade: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.cidade }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Estado: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ prot.uf }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Anotações Negativas – Protestos
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo &&
                                                     Array.isArray(ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.relacao_consultas_anteriores_credito_segmento) &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.relacao_consultas_anteriores_credito_segmento.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Histórico de Consultas de crédito
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.relacao_consultas_anteriores_credito_segmento"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.data }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Empresa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.informante }}</span>
                                                    </v-col>
                                                </v-row>
                                             </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Histórico de Consultas de crédito
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo &&
                                                     Array.isArray(ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.informacoes_complementares) &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.informacoes_complementares.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Ações Judiciais
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.informacoes_complementares"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Informação: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.texto }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">UF:
                                                        </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.ufOrigem }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Ações Judiciais
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo &&
                                                     Array.isArray(ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.relacao_falencia_recuperacao_judicial) &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.relacao_falencia_recuperacao_judicial.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Falências Bancárias
                                            </v-col>
                                            {{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.relacao_falencia_recuperacao_judicial }}
                                            <!--v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaSerasa.reports[0].facts.bankrupts.bankruptsResponse"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.occurrenceDate) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Empresa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.companyName }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col-->
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Falências Bancárias
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.participacoes_do_documento_consultado">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Sociedades
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Empresa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.participacoes_do_documento_consultado.razaoSocial }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Participação: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.participacoes_do_documento_consultado.valor }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">CNPJ: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.participacoes_do_documento_consultado.numeroDocumentoA }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Função: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.participacoes_do_documento_consultado.funcao }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Sociedades
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-row v-else-if="Cliente.tpdId == 2 && ListaCdl != null && ListaCdl.ConsultaDefineLimitePositivoResponse && ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult && ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo">
                                       <v-col cols="12" md="12" style="border-right: 1px solid #cccccc;">
                                        <v-row>
                                            <v-col cols="12" md="12">
                                                Dados Cadastrais
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Relatório: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>Consulta Define Limite Positivo</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Score: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.score.score_pj.score }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Status Consumidor: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.score.score_pj.texto }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Documento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.identificacao_completo.cnpj }}</span>
                                            </v-col>
                                             <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Razão Social: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.identificacao_completo.razao_social }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Fantasia:</span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.identificacao_completo.nome_fantasia }}</span>
                                            </v-col>
                                               <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Situação CNPJ: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.identificacao_completo.situacao_cnpj }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Natureza Juridica: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.identificacao_completo.natureza_juridica }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Data Fundação: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.identificacao_completo.data_fundacao }}</span>
                                            </v-col>
                                             <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Segmento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.identificacao_completo.segmento }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3"
                                                style="padding-bottom: 2px;padding-top:3px;">
                                                <span style="font-weight: 500;">Decisão Sugerida: </span>
                                            </v-col>
                                            <v-col cols="12" md="9"
                                                style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.decisao.descricao }}</span>
                                            </v-col>

                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.pendencias_restricoes != null">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                  {{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.pendencias_restricoes }}
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Pendências Financeiras
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                         <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.protestos != null">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Protestos
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                  {{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.protestos }}
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Protestos
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.cheques_sem_fundo != null">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Cheques sem fundos
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                  {{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.cheques_sem_fundo }}
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Cheques sem fundos
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.cheques_sustados != null">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Cheques sustados
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                  {{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.cheques_sustados }}
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Cheques sustados
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.acoes_civeis != null">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Ações Civeis
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                  {{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.acoes_civeis }}
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Ações Civeis
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     Array.isArray(ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.consultas.ultimas_consultas) &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.consultas.ultimas_consultas > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Histórico de Consultas de crédito
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.consultas.ultimas_consultas"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Data: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ formattedDate(convem.data) }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Empresa: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.razao_social }}</span>
                                                    </v-col>
                                                </v-row>
                                             </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Histórico de Consultas de crédito
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row
                                            v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.falencias_recuperacao_judicial != null">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Falências Bancárias
                                            </v-col>
                                              <v-col cols="12" md="12">
                                                 {{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.falencias_recuperacao_judicial }}
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Falências Bancárias
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click.prevent="exportPdf">Exportar PDF</v-btn>
                        <v-btn @click.prevent="dialogSerasa2 = false">Fechar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>


        <!--modal Cdl-->
         <v-row justify="center">
            <v-dialog v-model="dialogCdl" class="controlcelEnd gp-active-detail-dialog" transition="dialog-bottom-transition" width="auto" >
                <v-card ref="serasaContent">
                    <v-card-title style="background-color: #cccccc;">
                        <span class="text-h5" style="font-size: 19px !important;">Análise Crédito</span>
                        <span class="text-h5" style="font-size: 19px !important;" v-if="ConsultasCliente.filter(x=> x.tipo == 'cdl').length > 0"> - Data: {{ formattedDate(ConsultasCliente.filter(x=> x.tipo == 'cdl')[0].dtRetorno) }}</span>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" md="12" v-if="Cliente.tpdId == 1 && ListaCdl != '' && ListaCdl != null && ListaCdl.ConsultaFamiliaPositivoResponse && ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult && ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo"
                                       style="border-right: 1px solid #cccccc;">
                                           <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.score_classificacao_varios_modelos.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Classificação Score
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(pefin, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.score_classificacao_varios_modelos"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Decrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.descricaoNatureza }}</span>
                                                    </v-col>
                                                </v-row>
                                                 <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Score: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.score }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Texto: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.texto }}</span>
                                                    </v-col>
                                                </v-row>
                                                  <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Texto Complementar: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ pefin.texto2 }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Classificação Score
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>

                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_pagamento">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento - Pontualidade Parcelamentos
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_pagamento.nota_pontualidade.operacoes_parceladas.item_painel_controle"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Descrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.descricao }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.valor }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento - Pontualidade Parcelamentos
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>

                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_pagamento">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento - Pontualidade Cartão Crédito
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_pagamento.nota_pontualidade.cartao_credito.item_painel_controle"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Descrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.descricao }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.valor }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento - Pontualidade Cartão Crédito
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>

                                           <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo &&
                                                        ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_pagamento">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nota Atraso Fatura: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_pagamento.nota_comportamento_fatura_em_atraso.nota }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nota Adiantamento Fatura: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_pagamento.nota_comportamento_adiantamento_de_pagamento.nota }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_consumo">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Consumo - Comprometimento Parcelemantos
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_consumo.pontuacao_comprometimento.operacoes_parceladas.item_painel_controle"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Descrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.descricao }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.valor }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                               Comportamento Consumo - Comprometimento Parcelemantos
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo &&
                                                     ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_consumo">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Consumo - Comprometimento Cartão Crédito e Cheque Especial
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_consumo.pontuacao_comprometimento.cartao_credito_cheque_especial_e_outros_rotativos.item_painel_controle"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Descrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.descricao }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Valor: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.valor }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                               Comportamento Consumo - Comprometimento Cartão Crédito e Cheque Especial
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo &&
                                        ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_consumo">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento contratos recentes
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Nota contratos recentes: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo.painel_controle_positivo.indicadores_positivos_comportamento_consumo.nota_comportamento_contratos_recentes.nota }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" md="12" v-else-if="Cliente.tpdId == 2 && ListaCdl != null && ListaCdl.ConsultaDefineLimitePositivoResponse && ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult && ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo"
                                       style="border-right: 1px solid #cccccc;">
                                           <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.score.score_pj != null">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Classificação Score
                                            </v-col>
                                            <v-col cols="12" md="12">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Decrição: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.score.score_pj.texto }}</span>
                                                    </v-col>
                                                </v-row>
                                                 <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Score: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.score.score_pj.score }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Faturamento Presumido: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.faturamento_presumido.faturamento_anual }}</span>
                                                    </v-col>
                                                </v-row>
                                                  <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Texto Complementar: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.faturamento_presumido.mensagem }}</span>
                                                    </v-col>
                                                </v-row>
                                                  <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Limite de Crédito: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.limite_credito.score }}</span>
                                                    </v-col>
                                                </v-row>
                                                 <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Texto Complementar: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.limite_credito.texto }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Classificação Score
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>

                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.pagamento_pontual.lista_indicador_comportamento.item_indicador.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento - Pontualidade
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.pagamento_pontual.lista_indicador_comportamento.item_indicador"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Mês: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.mes_ano }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Pontuação: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.pontuacao_mensal }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento - Pontualidade
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.pagamento_atrasado.periodo_6_a_15_dias.lista_indicador_comportamento.item_indicador.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comportamento Pagamento - Atrasados
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.pagamento_atrasado.periodo_6_a_15_dias.lista_indicador_comportamento.item_indicador"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Mês: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.mes_ano }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Pontuação: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.pontuacao_mensal }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                               Comportamento Pagamento - Atrasados
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                          
                                        <v-row v-if="ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo &&
                                                     ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.comprometimento_futuro.lista_credito.credito.length > 0">
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                                Comprometimento Futuro
                                            </v-col>
                                            <v-col cols="12" md="12"
                                                v-for="(convem, index) in ListaCdl.ConsultaDefineLimitePositivoResponse.ConsultaDefineLimitePositivoResult.defineLimitePositivo.comprometimento_futuro.lista_credito.credito"
                                                :key="index"
                                                :class="index % 2 === 0 ? 'bg-custom-white' : 'bg-custom-light-blue'">
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Período: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.periodo }}</span>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12" md="3"
                                                        style="padding-bottom: 2px;padding-top:3px;">
                                                        <span style="font-weight: 500;">Pontuação: </span>
                                                    </v-col>
                                                    <v-col cols="12" md="9"
                                                        style="text-align: left;padding-bottom: 2px;padding-top:3px;">
                                                        <span>{{ convem.pontuacao }}</span>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <v-row v-else>
                                            <v-col cols="12" md="12" style="background-color: #cccccc;margin-top:30px;">
                                               Comprometimento Futuro
                                            </v-col>
                                            <v-row>
                                                <v-col cols="12" md="3" style="padding-bottom: 2px;padding-top:30px;">
                                                    <span style="font-weight: 500;">Nada Consta </span>
                                                </v-col>
                                            </v-row>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click.prevent="exportPdf">Exportar PDF</v-btn>
                        <v-btn @click.prevent="dialogCdl = false">Fechar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import moment from 'moment'
import { useRoute } from 'vue-router';
import VueSpeedometer from "vue-speedometer";

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';


export default {
    name: 'ContratacaoVigenteDetalheView',
    components: {
        EasyDataTable,
        moment,
        VueSpeedometer
    },
    setup() {
        const route = useRoute();
        const id = route.params.idPed;

        return {
            id,
        };
    },
    data: () => ({
         User: {
            garid:0,
            tpeid:0,
            pesid:0,
            cusid:0
        },
        tab: 'dados',
        secaoVigente:'analise',
        EtapasVigente:[
            { nome:'Dados', descricao:'Cadastro' },
            { nome:'Análise', descricao:'Validação' },
            { nome:'Documentos', descricao:'Pendências' },
            { nome:'Contrato', descricao:'Assinatura' },
            { nome:'Pagamento', descricao:'Cobrança' },
            { nome:'Conclusão', descricao:'Vigência' }
        ],
        NomeTela: 'Contratações',
        InfoTela: 'Detalhe Contratação',
        MostraGrid: true,
        Cliente: [],
        Imobiliaria: [],
        PlanosGarantias:[],
        headers: [],
        Idiomas: [],
        vshowidioma: true,
        CadastroTelas: [{ cdtId: 28, cdtNome: "Detalhe Contratação" }],
        PedidosCli: [],
        Pedidos: [],
        TotalPedido: 0,
        validacomprova: [],
        PedidosComprova: [],
        showModal_comprova: false,
        ListaPedidoItem: [],
        ListaPedidoItemAdicional: [],
        PedidosMensagem: [],
        PedidosAgendamento: [],
        PedidosEndereco: [],
        PedidosComprova:[],  
        Estados: [],
        Cidades: [],
        Bairros: [],
        selectedFile: '',
        urlComprovante: '',
        PedidoComprovante: [],
        Situacoes: [],
        dialogCliente:false,
        dialogImobiliaria:false,
        ListEndereco:[],
        EnderecoImob:{},
        ListEnderecoImob:[],
        Endereco:{},
        ValidaCustomer:{},
        DadosGarantidora:[],
         //Documentos
         ListDocumentos:[],
        Documentos: {
            cdoId:0,
            cdoDocumento:'', 
            cdoNomeDocumento:'', 
            cdoUrlDocumento:'',
            cliId:'',
        },
        DocSelected:null,
        ListaDocs:[],
        TiposDocumentos:[],
        ListEntidadesDocumentos:[],
        selectedFile: '',
        //serasa
        score: 0,
        dialogSerasa:false,
        dialogSerasa2:false,
        dialogCdl:false,
        ListaSerasa: null,
        ListaCdl: null,
        ListaJusBrasil: null,
        ListaSerasa2: null,
        ListaJusBrasil2: null,
        ListaInvoice: null,
        ListaProdutosImg:[],
        dialogJusBrasil: false,
        nomeDocumento:'',
        ContratoPedido:[],
        Assinatura:[],
        ListaContratos:[],
        ListDocumentosAssinado:[],
        ListDocumentosAss:null,
        salvandoContratoAssinado:false,
        reprocessandoContrato:false,
        //docs
        ListaDocs: [],
        //consultas
        ListaConsultas: [],
        ConsultasCliente: [],
        ConsultasConjuge: [],
        ConsultasCorresp1: [],
        ConsultasCorresp2: [],
    }),
    methods: {
        ValorNumero(valor) {
            if (typeof valor === 'number') return Number.isFinite(valor) ? valor : 0;
            const texto = String(valor ?? '').trim();
            if (!texto) return 0;
            const normalizado = texto.includes(',') ? texto.replace(/\./g, '').replace(',', '.') : texto;
            const numero = Number(normalizado.replace(/[^0-9.-]/g, ''));
            return Number.isFinite(numero) ? numero : 0;
        },
        AbrirSecaoVigente(secao) {
            this.secaoVigente = secao;
            this.tab = secao === 'analise' || secao === 'observacoes' ? 'dados' : secao;
        },
        CoberturaProduto(produto) {
            let dados = Array.isArray(this.ListDocumentosAss) ? this.ListDocumentosAss[0]?.pftDadosContrato : null;
            for (let tentativa = 0; tentativa < 3 && typeof dados === 'string'; tentativa += 1) {
                try { dados = JSON.parse(dados); } catch { dados = null; break; }
            }
            const multiplicador = dados?.multiplicador ?? dados?.Multiplicador;
            if (multiplicador) return String(multiplicador);
            const quantidade = Number(produto?.pdiQtdeProduto || 0);
            return quantidade > 0 ? `${quantidade}x` : '—';
        },
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        formattedDate(value) {
            if (value != null || value != "") {
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else {
                return "";
            }

        },
        formatarValor(valor) {
            // Verifica se o valor é inteiro
            if (Number.isInteger(valor)) {
                return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
            // Formata normalmente para valores com casas decimais
            return parseFloat(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        formatarTaxa(valor) {
            if (valor === null || valor === undefined || String(valor).trim() === '') return '—';
            const numero = Number(String(valor).replace('%', '').replace(',', '.').trim());
            if (!Number.isFinite(numero)) return '—';
            const percentual = Math.abs(numero) <= 1 ? numero * 100 : numero;
            return `${percentual.toLocaleString('pt-BR', { maximumFractionDigits: 4 })}%`;
        },
        async UploadImg(value) {
            const formData = new FormData();
            formData.append('file', value);
            const uploadResult = await axios.post(`/Telas/ContratacoesVigenteDetalhe/upload`, formData);
            return uploadResult;
        },
        buildFileUrl(path) {
            if (!path) return '';
            const rel  = String(path).replace(/\\/g, '/'); // normaliza separadores
            const base = this.$imgURL;
            return `${base}/Telas/ContratacoesVigenteDetalhe/GetFileByParam?param=${encodeURIComponent(rel)}&t=${Date.now()}`;
        },
        openInNewTab(path) {
            const url = this.buildFileUrl(path);
            if (!url) return;
            window.open(url, '_blank', 'noopener,noreferrer'); // nova aba
        },
        calculatotal() {
            var valorProdutos = 0;

            if (this.ListaPedidoItem != '') {
                this.ListaPedidoItem.forEach(item => {
                    valorProdutos += item.pdiValorTotalProduto;
                });
            }

            this.TotalPedido = (valorProdutos);
        },
        async openDialogCliente(value){
         //carrega endereco
         await axios.get(`/Telas/ContratacoesVigenteDetalhe/GetEnderecoByCli/`+ value)
                        .then(response => {
                            this.ListEndereco = response.data;                             
                            if (this.ListEndereco != ''){
                                this.Endereco = this.ListEndereco[0];
                                this.dialogCliente = true;
                                //console.log('this.Endereco')
                                //console.log(this.Endereco)
                            }            
                        });
        },
        async openDialogImobiliaria(value){
         //carrega endereco
         await axios.get(`/Telas/ContratacoesVigenteDetalhe/GetByImoIdEndereco/`+ value)
                        .then(response => {
                            this.ListEnderecoImob = response.data;                             
                            if (this.ListEnderecoImob != ''){
                                this.EnderecoImob = this.ListEnderecoImob[0];
                                this.dialogImobiliaria = true;
                                //console.log('this.EnderecoImob')
                                //console.log(this.EnderecoImob)
                            }            
                        });
        },
        async EnviarDocumento(){
            if (this.nomeDocumento == '' || this.nomeDocumento == null) {
                this.$mensagemAviso("Preencha nome do documento a ser enviado.")
            }
            else if (this.selectedFile == '' || this.selectedFile == null){
                this.$mensagemAviso("Selecione um Documento a ser enviado.")
            }
            else{
                if (this.selectedFile != '' && this.selectedFile != null) {
                    const arquivo = Array.isArray(this.selectedFile) ? this.selectedFile[0] : this.selectedFile;
                    const uploadSuccess = await this.UploadImg(arquivo);
                    if (uploadSuccess.status == 200) {
                        let _pedidoMensagem = {
                            PmsId: 0,
                            GrtId: 0,
                            CdtId: 0,
                            PmsUrlImagem: uploadSuccess.data.nameFile,
                            PmsNome: this.nomeDocumento,
                            PmsTipo: "",
                            PmsTexto: "", 
                            PmsCampoExtra1: "",
                            PedId: this.PedidosCli.pedId,
                         };
 
                         const inclusao = await axios.post(`/Telas/ContratacoesVigenteDetalhe/AddDocAnalise`, _pedidoMensagem);
                         if (inclusao.data > 0) {
                            let documentos = (await axios.get('/Telas/ContratacoesVigenteDetalhe/GetAllByPedIdDocAnalise/' + this.PedidosCli.pedId)).data;
                            if (this.DocSelected?.pmsNome) {
                                const pendente = documentos.find(x => x.pmsNome == this.DocSelected.pmsNome && !x.pmsUrlImagem);
                                if (pendente) {
                                    await axios.delete(`/Telas/ContratacoesVigenteDetalhe/DeleteDocAnalise/${pendente.pmsId}`);
                                    documentos = (await axios.get('/Telas/ContratacoesVigenteDetalhe/GetAllByPedIdDocAnalise/' + this.PedidosCli.pedId)).data;
                                }
                            }
                            this.ListDocumentos = documentos;
                            this.DocSelected = null;
                            this.selectedFile = '';
                            this.nomeDocumento = '';
                            this.$mensagemAvisoSucesso('Documento enviado com sucesso.');
                         }
                    }
                    else {
                        this.$mensagemErro("Não foi possível carregar imagem.")
                    }
              }
         }
        },
        DeleteDocumento(item){
            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
                const param1 = item.pmsId;
                axios.delete(`/Telas/ContratacoesVigenteDetalhe/DeleteDocAnalise/${param1}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Registro Excluido.")
                         //carrega documentos
                         axios.get('/Telas/ContratacoesVigenteDetalhe/GetAllByPedIdDocAnalise/' + this.PedidosCli.pedId)
                        .then(response => {
                            this.ListDocumentos = response.data;
                        })
                        .catch(error => {
                            console.error(error);
                        });
                    }
                });
            }
            });
        },
        AcionarSinistro(){

        },
        async exportPdf() {
            console.log('🖨️ exportPdf iniciado')
            // 1) Aguarda o Vue terminar de renderizar
            await this.$nextTick()

            // 2) Busca o ref
            let element = this.$refs.serasaContent

            // Se for um componente Vue, pega o elemento real
            if (element && element.$el) {
                element = element.$el
                console.log('🔍 usando element.$el =', element)
            }

            // Verifica se está no documento
            if (!element || !document.body.contains(element)) {
                console.error('❌ Elemento não encontrado ou não anexado ao DOM')
                return
            }

            // 3) Faz o clone off-screen
            const clone = element.cloneNode(true)
            Object.assign(clone.style, {
                position: 'absolute',
                top: '-9999px',
                left: '-9999px',
                width: `${element.offsetWidth}px`,
                maxHeight: 'none',
                overflow: 'visible'
            })
            document.body.appendChild(clone)
            console.log('📋 clone adicionado ao body:', clone)

            try {
                // 4) Renderiza o clone
                console.log('⏳ chamando html2canvas em clone…')
                const canvas = await html2canvas(clone, { scale: 2, useCORS: true })
                console.log('✅ canvas gerado')

                // 5) Remove o clone
                document.body.removeChild(clone)
                console.log('🧹 clone removido')

                // 6) Gera o PDF
                const imgData = canvas.toDataURL('image/png')
                const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' })

                const margin    = 10;   
                const pageW = pdf.internal.pageSize.getWidth()
                const pageH = pdf.internal.pageSize.getHeight()
                const props = pdf.getImageProperties(imgData)
                const imgW = pageW
                const imgH = (props.height * pageW) / props.width

                let posY = margin;
                pdf.addImage(imgData, 'PNG', 0, posY, imgW, imgH)

                while (imgH - Math.abs(posY) > pageH) {
                    posY -= pageH
                    pdf.addPage()
                    pdf.addImage(imgData, 'PNG', 0, posY, imgW, imgH)
                }

                pdf.save('analise_credito.pdf')
                console.log('✅ PDF salvo')
            }
            catch (err) {
                console.error('❌ erro ao gerar PDF:', err)
                // garante remoção do clone
                if (document.body.contains(clone)) {
                    document.body.removeChild(clone)
                }
            }
        },
         async export2Pdf() {
            console.log('🖨️ exportPdf iniciado')
            // 1) Aguarda o Vue terminar de renderizar
            await this.$nextTick()

            // 2) Busca o ref
            let element = this.$refs.jusContent

            // Se for um componente Vue, pega o elemento real
            if (element && element.$el) {
                element = element.$el
                console.log('🔍 usando element.$el =', element)
            }

            // Verifica se está no documento
            if (!element || !document.body.contains(element)) {
                console.error('❌ Elemento não encontrado ou não anexado ao DOM')
                return
            }

            // 3) Faz o clone off-screen
            const clone = element.cloneNode(true)
            Object.assign(clone.style, {
                position: 'absolute',
                top: '-9999px',
                left: '-9999px',
                width: `${element.offsetWidth}px`,
                maxHeight: 'none',
                overflow: 'visible'
            })
            document.body.appendChild(clone)
            console.log('📋 clone adicionado ao body:', clone)

            try {
                // 4) Renderiza o clone
                console.log('⏳ chamando html2canvas em clone…')
                const canvas = await html2canvas(clone, { scale: 2, useCORS: true })
                console.log('✅ canvas gerado')

                // 5) Remove o clone
                document.body.removeChild(clone)
                console.log('🧹 clone removido')

                // 6) Gera o PDF
                const imgData = canvas.toDataURL('image/png')
                const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' })

                const margin    = 10;   
                const pageW = pdf.internal.pageSize.getWidth()
                const pageH = pdf.internal.pageSize.getHeight()
                const props = pdf.getImageProperties(imgData)
                const imgW = pageW
                const imgH = (props.height * pageW) / props.width

                let posY = margin;
                pdf.addImage(imgData, 'PNG', 0, posY, imgW, imgH)

                while (imgH - Math.abs(posY) > pageH) {
                    posY -= pageH
                    pdf.addPage()
                    pdf.addImage(imgData, 'PNG', 0, posY, imgW, imgH)
                }

                pdf.save('analise_juridica.pdf')
                console.log('✅ PDF salvo')
            }
            catch (err) {
                console.error('❌ erro ao gerar PDF:', err)
                // garante remoção do clone
                if (document.body.contains(clone)) {
                    document.body.removeChild(clone)
                }
            }
        },
        CarregaDocs(_cliId) {
            axios.get(`/Telas/ContratacoesVigenteDetalhe/GetBycliIdDocs/` + _cliId)
                .then(response => {
                    if (response.data.length > 0) {
                        this.ListaDocs = response.data;
                    }
                    else {
                        this.ListaDocs = [];
                    }
                });
        },
        VisualizarDocumento(item) {
         if (item) {
           this.openInNewTab(item);
          }
        },
        CarregaConsultas(_cliId) {
            axios.get(`/Telas/ContratacoesVigenteDetalhe/GetBycliIdConsulta/` + _cliId)
                .then(response => {
                    if (response.data.length > 0) {
                        this.ListaConsultas = response.data;
                        this.completaConsultasClienteAvulsas();
                    }
                    else {
                        this.ListaConsultas = [];
                    }
                });
        },
        limparDocumento(value) {
            return value ? String(value).replaceAll('.', '').replaceAll('-', '').replaceAll('/','') : '';
        },
        getConsulta(lista, tipo) {
            return Array.isArray(lista) ? lista.find(x => x.tipo == tipo) : null;
        },
        normalizaConsultasCredito(lista) {
            if (!Array.isArray(lista)) {
                return [];
            }

            return lista.map(item => ({
                documento: item.documento ?? item.Documento,
                dtRetorno: item.dtRetorno ?? item.DtRetorno,
                mensagem: item.mensagem ?? item.Mensagem,
                obsAnalise: item.obsAnalise ?? item.ObsAnalise,
                retorno: item.retorno ?? item.Retorno,
                score: item.score ?? item.Score,
                statusRetorno: item.statusRetorno ?? item.StatusRetorno,
                tipo: item.tipo ?? item.Tipo,
            }));
        },
        completaConsultasClienteAvulsas() {
            if (!Array.isArray(this.ListaConsultas) || this.ListaConsultas.length == 0) {
                return;
            }

            if (!Array.isArray(this.ConsultasCliente)) {
                this.ConsultasCliente = [];
            }

            const consulta = this.ListaConsultas.find(x => x.ccsSerasa || x.CcsSerasa || x.ccsJusBrasil || x.CcsJusBrasil || x.ccsJusbrasil || x.CcsJusbrasil);
            const document = this.limparDocumento(this.Cliente.cliDocumento);
            const serasa = consulta?.ccsSerasa ?? consulta?.CcsSerasa;
            const jusBrasil = consulta?.ccsJusBrasil ?? consulta?.CcsJusBrasil ?? consulta?.ccsJusbrasil ?? consulta?.CcsJusbrasil;
            const dataConsulta = consulta?.ccsDataConsulta ?? consulta?.CcsDataConsulta;

            if (serasa && this.ConsultasCliente.filter(x=> x.tipo == 'ser').length == 0) {
                this.ConsultasCliente.push({
                    documento: document,
                    dtRetorno: dataConsulta,
                    mensagem: '',
                    obsAnalise: null,
                    retorno: serasa,
                    score: this.extraiScoreSerasa(serasa),
                    statusRetorno: '200',
                    tipo: 'ser'
                });
            }

            if (jusBrasil && this.ConsultasCliente.filter(x=> x.tipo == 'jus').length == 0) {
                this.ConsultasCliente.push({
                    documento: document,
                    dtRetorno: dataConsulta,
                    mensagem: '',
                    obsAnalise: null,
                    retorno: jusBrasil,
                    score: 0,
                    statusRetorno: '200',
                    tipo: 'jus'
                });
            }
        },
        extraiScoreSerasa(value) {
            try {
                const parsed = JSON.parse(value);
                return parsed?.reports?.[0]?.score?.score ?? 0;
            }
            catch {
                return 0;
            }
        },
        getScoreConsulta(lista) {
            const serasa = this.getConsulta(lista, 'ser');
            if (serasa?.score != null) {
                return serasa.score;
            }

            const cdlScore = this.getCdlScore(lista);
            return cdlScore != null ? cdlScore : 0;
        },
        getObsConsulta(lista, tipo, label) {
            const consulta = this.getConsulta(lista, tipo);
            return consulta?.obsAnalise ? `${label}: ${consulta.obsAnalise}` : null;
        },
        getCdlScore(lista) {
            try {
                const cdl = this.getConsulta(lista, 'cdl');
                if (!cdl?.retorno) {
                    return null;
                }

                const retorno = JSON.parse(cdl.retorno);
                const score = retorno?.ConsultaFamiliaPositivoResponse?.ConsultaFamiliaPositivoResult?.completo?.score_classificacao_varios_modelos;
                return Array.isArray(score) ? score[0]?.score ?? null : score?.score ?? null;
            }
            catch {
                return null;
            }
        },
        isRetornoCpfNotAvailable(item) {
            if (!item?.retorno) {
                return false;
            }

            try {
                const retorno = JSON.parse(item.retorno);
                const mensagem = JSON.stringify(retorno).toUpperCase();
                return mensagem.includes('CPF NAO DISPONIVEL') || mensagem.includes('CPF NÃO DISPONÍVEL');
            }
            catch {
                return String(item.retorno).toUpperCase().includes('CPF NAO DISPONIVEL');
            }
        },
        CarregaConsultasDocumento(_document, target, usarFallbackPedido = false) {
            const document = this.limparDocumento(_document);
            if (!document) {
                this[target] = [];
                return;
            }

            axios.get(`/Telas/ContratacoesVigenteDetalhe/GetAllByConsultasCreditoByDocId/` + document)
                .then(response => {
                    this[target] = this.normalizaConsultasCredito(response.data);

                    if (usarFallbackPedido) {
                        this.completaConsultasPedidoAtual(target, document);
                    }

                    if (target == 'ConsultasCliente') {
                        this.completaConsultasClienteAvulsas();
                    }
                })
                .catch(error => {
                    console.error(error);
                    this[target] = [];

                    if (usarFallbackPedido) {
                        this.completaConsultasPedidoAtual(target, document);
                    }

                    if (target == 'ConsultasCliente') {
                        this.completaConsultasClienteAvulsas();
                    }
                });
        },
        completaConsultasPedidoAtual(target, document) {
            if (!Array.isArray(this[target])) {
                this[target] = [];
            }

            if (this[target].filter(x=> x.tipo == 'ser').length == 0 && this.PedidosCli.pedSerasa) {
                this[target].push({
                    documento: document,
                    dtRetorno: this.PedidosCli.pedDataPedido,
                    mensagem: '',
                    obsAnalise: this.PedidosCli.pedObsAnalise,
                    retorno: this.PedidosCli.pedSerasa,
                    score: this.PedidosCli.pedScore,
                    statusRetorno: '200',
                    tipo: 'ser'
                });
            }

            if (this[target].filter(x=> x.tipo == 'jus').length == 0 && this.PedidosCli.pedJusBrasil) {
                this[target].push({
                    documento: document,
                    dtRetorno: this.PedidosCli.pedDataPedido,
                    mensagem: '',
                    obsAnalise: this.PedidosCli.pedObsAnalise,
                    retorno: this.PedidosCli.pedJusBrasil,
                    score: this.PedidosCli.pedScore,
                    statusRetorno: '200',
                    tipo: 'jus'
                });
            }
        },
        CarregaModalSerasaCredito(value) {
            this.ListaSerasa = JSON.parse(value);
            this.dialogSerasa = !this.dialogSerasa;
        },
        normalizeListaCdl(list) {
            if (!list || !list.ConsultaFamiliaPositivoResponse?.ConsultaFamiliaPositivoResult?.completo) {
                return;
            }

            const completo = list.ConsultaFamiliaPositivoResponse.ConsultaFamiliaPositivoResult.completo;

            [
                'debitos',
                'titulos_protestados',
                'relacao_consultas_anteriores_credito_segmento',
                'informacoes_complementares',
                'relacao_falencia_recuperacao_judicial'
            ].forEach(field => {
                const fieldValue = completo[field];
                if (fieldValue && !Array.isArray(fieldValue) && fieldValue.registro === 'S') {
                    completo[field] = [fieldValue];
                }
            });

            if (completo.score_classificacao_varios_modelos && !Array.isArray(completo.score_classificacao_varios_modelos)) {
                completo.score_classificacao_varios_modelos = [completo.score_classificacao_varios_modelos];
            }
        },
        CarregaModalSerasaCredito2(value) {
            try {
                const parsed = JSON.parse(value);
                this.normalizeListaCdl(parsed);
                this.ListaCdl = parsed;
            }
            catch (error) {
                console.error('Erro ao parsear ListaCdl em CarregaModalSerasaCredito2:', error);
                this.ListaCdl = null;
            }
            this.dialogSerasa2 = !this.dialogSerasa2;
        },
        CarregaModalJusCredito(value) {
            const cleanedJson = value
                .replace(/,\s*}/g, '}')
                .replace(/,\s*]/g, ']');

            this.ListaJusBrasil = JSON.parse(cleanedJson);
            this.dialogJusBrasil = !this.dialogJusBrasil;
        },
        CarregaModalCdlCredito(value) {
            try {
                const parsed = JSON.parse(value);
                this.normalizeListaCdl(parsed);
                this.ListaCdl = parsed;
            }
            catch (error) {
                console.error('Erro ao parsear ListaCdl em CarregaModalCdlCredito:', error);
                this.ListaCdl = null;
            }
            this.dialogCdl = !this.dialogCdl;
        },
        CarregaModalSerasa2(value) {
            this.ListaSerasa = value;
            this.dialogSerasa = !this.dialogSerasa;
        },
         CarregaModalJus2(value) {
            this.ListaJusBrasil = value;
            this.dialogJusBrasil = !this.dialogJusBrasil;
        },
        CarregaModalSerasa(value) {
            this.ListaSerasa = JSON.parse(value.ccsSerasa);
            this.dialogSerasa = !this.dialogSerasa;
        },
        CarregaModalJus(value) {
            const cleanedJson = value.ccsJusBrasil
                .replace(/,\s*}/g, '}')
                .replace(/,\s*]/g, ']');

            const parsedData = JSON.parse(cleanedJson);
            this.ListaJusBrasil = parsedData;
            this.dialogJusBrasil = !this.dialogJusBrasil;
        },
        async UploadContratoAssinadoFisico(event){
            const arquivo = event?.target?.files?.[0];
            if (!arquivo) return;
            event.target.value = '';
            if (arquivo.type !== 'application/pdf' && !arquivo.name?.toLowerCase().endsWith('.pdf')) {
                this.$mensagemAviso('Selecione um arquivo PDF.');
                return;
            }
            const contrato = Array.isArray(this.ListDocumentosAss) ? this.ListDocumentosAss[0] : null;
            if (!contrato?.pftId) {
                this.$mensagemAviso('Não foi encontrado um contrato para receber o arquivo assinado.');
                return;
            }
            if (contrato.pftUrlDocAssinado) {
                const confirmar = await this.$mensagemConfirma('Já existe um contrato assinado. Deseja substituí-lo pelo novo arquivo?');
                if (!confirmar?.isConfirmed) return;
            }
            this.salvandoContratoAssinado = true;
            try {
                const upload = await this.UploadImg(arquivo);
                if (upload?.status !== 200 || !upload?.data?.nameFile) throw new Error('Não foi possível carregar o arquivo.');
                const atualizado = { ...contrato, pftUrlDocAssinado: upload.data.nameFile };
                const response = await axios.put('/Telas/ContratacoesVigenteDetalhe/PutPedidoDocumento', atualizado);
                if (!(response.data > 0)) throw new Error('Não foi possível vincular o arquivo ao contrato.');
                this.$mensagemAvisoSucesso(contrato.pftUrlDocAssinado ? 'Contrato assinado substituído.' : 'Contrato assinado anexado.');
                await this.Get();
            } catch (error) {
                this.$mensagemErro(error?.response?.data?.message || error?.response?.data || error?.message || 'Não foi possível anexar o contrato assinado.');
            } finally {
                this.salvandoContratoAssinado = false;
            }
        },
        async ReprocessarContrato(listDocumentosAss){
            if (this.reprocessandoContrato) return;
            if (this.User.garid != 0) {
                this.$mensagemAviso('O reprocessamento do contrato está disponível somente para o perfil Master.');
                return;
            }
            const contratoAnterior = Array.isArray(listDocumentosAss) ? listDocumentosAss[0] : null;
            if (!contratoAnterior?.pftId || !contratoAnterior?.pftDadosContrato) {
                this.$mensagemAviso('Não existe um contrato com dados suficientes para reprocessar.');
                return;
            }

            const result = await this.$mensagemConfirma('Confirma o reprocessamento desse documento?');
            if (!result?.isConfirmed) return;
            this.reprocessandoContrato = true;
            try {
                // O novo documento é gerado antes da remoção do anterior. Se a geração
                // falhar, o contrato vigente continua preservado.
                const novoDocumentoId = await this.ContratoAdd(this.PedidosCli.pedId, contratoAnterior.pdiId, contratoAnterior.pftDadosContrato);
                if (!(novoDocumentoId > 0)) throw new Error('Não foi possível gerar o novo contrato.');

                const resultadoAssinatura = await this.EnviarAssinatura(this.PedidosCli, { assinaturaContratado: 0 }, novoDocumentoId);
                if (resultadoAssinatura !== 1) throw new Error('O contrato foi gerado, mas não foi possível enviá-lo para assinatura.');
                await axios.delete(`/Telas/ContratacoesVigenteDetalhe/DeleteDocPdf/${parseInt(contratoAnterior.pftId)}`);

                this.$mensagemAvisoConfirm('Documento reprocessado e enviado para assinatura.');
                await this.Get();
            } catch (error) {
                this.$mensagemErro(error?.response?.data?.message || error?.response?.data || error?.message || 'Erro no reprocessamento. Contate o suporte.');
            } finally {
                this.reprocessandoContrato = false;
            }
        },
        async ContratoAdd(_pedId, _pdiId, _dadosjson) {
                 let _dadosjsonpross = JSON.parse(_dadosjson);

                //validar se o cliente tem um contrato especifico
                let _cmcId = 4;
                if (this.Cliente.tpdId == 2) {
                    _cmcId = 5;
                }
                
                let result = this.ListaContratos.filter(x=> x.garId == this.DadosGarantidora.garId && x.tpdId == this.Cliente.tpdId);
                if (result.length > 0){
                   _cmcId = result[0].cmcId;
                }

                var _dadosContrato = {
                    TipoPessoa: 4,
                    CmcId: _cmcId,
                    IdContratante: this.Cliente.cliId,
                    IdContratada: this.DadosGarantidora.garId,
                    dadosContratacao: {
                        idPedido: _pedId,
                        multiplicador: _dadosjsonpross.multiplicador,
                        valorContratado: _dadosjsonpross.valorContratado.toString(),
                        custoSaida: _dadosjsonpross.custoSaida,
                        valorLocaticio: _dadosjsonpross.valorLocaticio,
                        valorTaxa: _dadosjsonpross.valorTaxa.toString(),
                        setup: _dadosjsonpross.setup.toString(),
                        tipoCalculoTaxa: (_dadosjsonpross.tipoCalculoTaxa || 'taxa').toString(),
                        valorPacoteInformado: _dadosjsonpross.valorPacoteInformado != null ? _dadosjsonpross.valorPacoteInformado.toString() : null
                    }
                }

                var _fileName = await this.Uploadpdf(_dadosContrato);

                var _pedidoDocumento = {
                    pftId: 0,
                    grtId: 0,
                    cdtId: 0,
                    pftUrlImagem: _fileName,
                    pedId: _pedId,
                    pdiId: _pdiId,
                    pftDadosContrato: JSON.stringify(_dadosContrato.dadosContratacao)
                }

                const response = await axios.post(`/Telas/ContratacoesVigenteDetalhe/AddPedidoDocumento`, _pedidoDocumento);
                if (response.data > 0) _pedidoDocumento.pftId = response.data;
                return _pedidoDocumento.pftId;
            
        },
        async EnviarAssinatura(pedi, _saldo, somenteDocumentoId = null) {
        try {
            const responseGarantidora = await axios.get(
            `/Telas/ContratacoesVigenteDetalhe/GetByGarIdAssinatura/` + this.DadosGarantidora.garId
            );

            if (responseGarantidora.data.length === 0) {
            console.error("Nenhuma garantidora encontrada para o ID fornecido.");
            return 0;
            }
            this.Assinatura = responseGarantidora.data[0];

            const responseDocumentos = await axios.get(
            `/Telas/ContratacoesVigenteDetalhe/GetAllByPedIdPedidoDocumento/` + pedi.pedId
            );
            if (responseDocumentos.data.length === 0) {
            console.error("Nenhum documento encontrado para o pedido.");
            return 0;
            }
            this.ContratoPedido = somenteDocumentoId
                ? responseDocumentos.data.filter(item => Number(item.pftId) === Number(somenteDocumentoId))
                : responseDocumentos.data;
            if (this.ContratoPedido.length === 0) {
                console.error('O novo contrato não foi localizado para envio.');
                return 0;
            }

            for (const element of this.ContratoPedido) {
            const idContrato = element.pftId;
            const tpeId = 4;

            const DadosEnvelopeRequest = {
                token: this.Assinatura.gasToken,
                envelopeDescricao: this.ListaContratos.find(x => x.cmcId == 4).cmcNome,
                repositorioId: parseInt(this.Assinatura.gasIdRepositorio),
                listaDocumentos: [{ UrlArquivo: element.pftUrlImagem }],
                listaSignatariosEnvelopes: []
            };

            // 1) adiciona sempre o cliente em 1º
            const signatarios = [{
                Ordem: 1,
                EmailSignatario: this.Cliente.cliEmail,
                NomeSignatario: this.Cliente.cliNomeEmpresa,
                CelularSignatario: this.Cliente.cliWhatsapp.replaceAll('-','').replaceAll('(','').replaceAll(')','').replaceAll('.',''),
                TipoAssinatura: 1,
                OpcaoAutenticacao: this.Assinatura.gasOpcaoAutenticacao,
                ExigirCodigo: this.Assinatura.gasExigirCodigo,
                CodigoExigido: this.Assinatura.gasCodigoExigido,
                AnalisarFaceImagem: this.Assinatura.gasAnalisarFaceImagem,
                PercentualPrecisaoFace: this.Assinatura.gasPercentualPrecisaoFace,
                EnviarWhatsapp: this.Assinatura.gasEnviarWhatsapp
            }];

            // 2) se existir 1º corresponsável, adiciona
            if (this.Cliente.cliNomeCorresponsavel) {
                signatarios.push({
                Ordem: null, // será renumerado
                EmailSignatario: this.Cliente.cliEmailCorresponsavel,
                NomeSignatario: this.Cliente.cliNomeCorresponsavel,
                CelularSignatario: this.Cliente.cliWhatsappCorresponsavel.replaceAll('-','').replaceAll('(','').replaceAll(')','').replaceAll('.',''),
                TipoAssinatura: 9,
                OpcaoAutenticacao: this.Assinatura.gasOpcaoAutenticacao,
                ExigirCodigo: this.Assinatura.gasExigirCodigo,
                CodigoExigido: this.Assinatura.gasCodigoExigido,
                AnalisarFaceImagem: this.Assinatura.gasAnalisarFaceImagem,
                PercentualPrecisaoFace: this.Assinatura.gasPercentualPrecisaoFace,
                EnviarWhatsapp: this.Assinatura.gasEnviarWhatsapp
                });
            }

            // 3) se existir 2º corresponsável, adiciona
            if (this.Cliente.cliNomeCorresponsavel2) {
                signatarios.push({
                Ordem: null,
                EmailSignatario: this.Cliente.cliEmailCorresponsavel2,
                NomeSignatario: this.Cliente.cliNomeCorresponsavel2,
                CelularSignatario: this.Cliente.cliWhatsappCorresponsavel2.replaceAll('-','').replaceAll('(','').replaceAll(')','').replaceAll('.',''),
                TipoAssinatura: 9,
                OpcaoAutenticacao: this.Assinatura.gasOpcaoAutenticacao,
                ExigirCodigo: this.Assinatura.gasExigirCodigo,
                CodigoExigido: this.Assinatura.gasCodigoExigido,
                AnalisarFaceImagem: this.Assinatura.gasAnalisarFaceImagem,
                PercentualPrecisaoFace: this.Assinatura.gasPercentualPrecisaoFace,
                EnviarWhatsapp: this.Assinatura.gasEnviarWhatsapp
                });
            }

            // 4) garantidora sempre por último
            signatarios.push({
                Ordem: null,
                EmailSignatario: this.DadosGarantidora.garEmail,
                NomeSignatario: this.DadosGarantidora.garNomeEmpresa,
                TipoAssinatura: 1,
            });

            // renumera sequencialmente
            signatarios.forEach((s, i) => {
                s.Ordem = i + 1;
            });

            DadosEnvelopeRequest.listaSignatariosEnvelopes = signatarios;

            // envia criação do envelope
            let responseEnvelope;
            try {
                responseEnvelope = await axios.post(
                `/Telas/ContratacoesVigenteDetalhe/AstenCreateEnvelope/${idContrato}/${tpeId}`,
                DadosEnvelopeRequest
                );

                if (responseEnvelope.status === 200) {
                    console.log("Envelope criado com sucesso:", responseEnvelope.data);
                } else {
                console.error(
                    "Erro ao criar envelope:",
                    responseEnvelope.status,
                    responseEnvelope.data
                );
                return 0;
                }
            } catch (error) {
                 const status = error.response?.status;
                 const data   = error.response?.data;
                console.error("Erro ao enviar assinatura:", error.message, { status, data });
                return 0;
            }
            }

            return 1;
        } catch (error) {
            console.error("Erro geral na função EnviarAssinatura:", error.message + ' - ' + responseEnvelope);
            return 0;
        }
        },
        async Uploadpdf(dadosContrato) {
                const uploadResult = await axios.post(`/Telas/ContratacoesVigenteDetalhe/uploadContratoPdf`, dadosContrato);
                return uploadResult.data.nameFile;
        },    
        CancelarVigencia(){
         this.$mensagemConfirma('Ao cancelar um contrato vigente, não é possível reverter, deseja continuar?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
             const data = moment().format('YYYY-MM-DD_HH-mm'); 
             const param2Raw = `Cancelamento Contratação Vigente - Usuário: ${this.User.cusid} - Data: ${data}`;
             const param2 = encodeURIComponent(param2Raw);
                const param1 = this.PedidosCli.pedId;
                axios.post(`/Telas/ContratacoesVigenteDetalhe/EncerramentoContratacaoVigencia/${param1}/${param2}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Contratação Encerrada.")
                        this.$router.push('/listacontratacoes');
                    }
                });
            }
            });
        },
        async Get() {
               await axios.get(`/Telas/ContratacoesVigenteDetalhe/GetDados`)
                .then(response => {
                     this.User.garid = response.data.garId;
                      this.User.tpeid = response.data.tpeId;
                      this.User.pesid = response.data.pesId;
                      this.User.cusid = response.data.cusId;
                      if (this.User.tpeid == 3 && this.secaoVigente === 'analise') this.secaoVigente = 'observacoes';
                });

            await axios.get(`/Telas/ContratacoesVigenteDetalhe/GetByIdPedidos/` + this.id)
                .then(response => {
                    this.PedidosCli = response.data;
                    // console.log('this.PedidosCli')
                    // console.log(this.PedidosCli)
                    if (this.PedidosCli.pedSerasa != '' && this.PedidosCli.pedSerasa != null){
                    this.score = this.PedidosCli.pedScore;
                    this.ListaSerasa2 = JSON.parse(this.PedidosCli.pedSerasa);
                    }

                    if (this.PedidosCli.pedJusBrasil != '' && this.PedidosCli.pedJusBrasil != null) {
                        const cleanedJson = this.PedidosCli.pedJusBrasil
                            .replace(/,\s*}/g, '}')
                            .replace(/,\s*]/g, ']');

                        const parsedData = JSON.parse(cleanedJson);

                        // Filtrar processos mantendo apenas aqueles que tenham o nome nas partes como EXECUTADO ou REU
                        let nomeFiltro = "";
                        // Filtrar processos mantendo apenas aqueles que tenham o nome nas partes como EXECUTADO ou REU
                        if (parsedData.nome != null && parsedData.nome != ''){
                            nomeFiltro = parsedData.nome.toLowerCase();
                        }

                         this.ListaJusBrasil2 = parsedData;
                    }


                    if (this.PedidosCli.pedInvoiceId != '' && this.PedidosCli.pedInvoiceId != null && this.PedidosCli.pedInvoiceId != '-'){
                        this.ListaInvoice = JSON.parse(this.PedidosCli.pedInvoiceId);
                        //  console.log('this.Cliente')
                        //  console.log(this.Cliente)
                    }


                    axios.get(`/Telas/ContratacoesVigenteDetalhe/GetByIdClientes/` + this.PedidosCli.cliId)
                    .then(response => {
                        this.Cliente = response.data;
                        this.ConsultasCliente = [];
                        this.completaConsultasPedidoAtual('ConsultasCliente', this.limparDocumento(this.Cliente.cliDocumento));
                        this.completaConsultasClienteAvulsas();
                        this.CarregaConsultasDocumento(this.Cliente.cliDocumento, 'ConsultasCliente', true);
                        this.CarregaConsultasDocumento(this.Cliente.cliCpfConjuge, 'ConsultasConjuge');
                        this.CarregaConsultasDocumento(this.Cliente.cliCpfCorresponsavel, 'ConsultasCorresp1');
                        this.CarregaConsultasDocumento(this.Cliente.cliCpfCorresponsavel2, 'ConsultasCorresp2');
                        //  console.log('this.Cliente')
                        //  console.log(this.Cliente)
                    });

                    axios.get(`/Telas/ContratacoesVigenteDetalhe/GetByIdImobiliaria/` + this.PedidosCli.imobId)
                        .then(response => {
                            this.Imobiliaria = response.data;
                            //  console.log('this.Imobiliaria')
                            //  console.log(this.Imobiliaria)
                     });

                     axios.get(`/Telas/ContratacoesVigenteDetalhe/GetByIdGarantidoras/` + this.PedidosCli.garId)
                        .then(response => {
                            this.DadosGarantidora = response.data;
                            //  console.log('this.Imobiliaria')
                            //  console.log(this.Imobiliaria)
                     });

                     axios.get('/Telas/ContratacoesVigenteDetalhe/GetAllByPedIdDocAnalise/' + this.PedidosCli.pedId)
                        .then(response => {
                            this.ListDocumentos = response.data;
                        })
                        .catch(error => {
                            console.error(error);
                        });

                        axios.get(`/Telas/ContratacoesVigenteDetalhe/GetAllModelosContrato`)
                        .then(response => {
                            this.ListaContratos = response.data.filter(x=> x.tpeId == 1 && x.cmcAtivo);
                        });

                        axios.get('/Telas/ContratacoesVigenteDetalhe/GetAllByPedIdPedidoDocumento/' + this.PedidosCli.pedId)
                        .then(response => {
                            this.ListDocumentosAss = response.data;
                           /* if (this.ListDocumentosAss != '' && this.ListDocumentosAss != null){
                                this.ListDocumentosAssinado = JSON.parse(this.ListDocumentosAss[0]);
                                //  console.log('this.Cliente')
                                //  console.log(this.Cliente)
                            }*/
                        })
                        .catch(error => {
                            console.error(error);
                        });
                   
                         this.CarregaDocs(this.PedidosCli.cliId);
                    this.CarregaConsultas(this.PedidosCli.cliId);

                });

            await axios.get('/Telas/ContratacoesVigenteDetalhe/GetAllByPedIdPedidoItem/' + this.PedidosCli.pedId)
                .then(response => {
                    this.ListaPedidoItem = response.data;

                    this.ListaPedidoItem = this.ListaPedidoItem.map(produto => ({
                        ...produto,
                        pdiDataVigenciaIni: produto.pdiDataVigenciaIni.split('T')[0],
                        pdiDataVigenciaFim: produto.pdiDataVigenciaFim.split('T')[0]
                    }));

                   // console.log('ListaPedidoItem')
                   // console.log(this.ListaPedidoItem)
                })
                .catch(error => {
                    console.error(error);
                });

            await axios.get('/Telas/ContratacoesVigenteDetalhe/GetAllByPedIdItemAdicional/' + this.PedidosCli.pedId)
                .then(response => {
                    this.ListaPedidoItemAdicional = response.data;
                   // console.log('ListaPedidoItemAdicional')
                   // console.log(this.ListaPedidoItemAdicional)
                })
                .catch(error => {
                    console.error(error);
                });


            axios.get('/Telas/ContratacoesVigenteDetalhe/GetAllByPedIdEndereco/' + this.PedidosCli.pedId)
                .then(response => {
                    this.PedidosEndereco = response.data;
                   // console.log('PedidosEndereco')
                   // console.log(this.PedidosEndereco)
                })
                .catch(error => {
                    console.error(error);
                });

                axios.get('/Telas/ContratacoesVigenteDetalhe/GetAllByPedIdComprovaPgto/' + this.PedidosCli.pedId)
                .then(response => {
                    this.PedidosComprova = response.data;
                   // console.log('PedidosComprova')
                   // console.log(this.PedidosComprova)
                })
                .catch(error => {
                    console.error(error);
                });


            axios.get(`/Telas/ContratacoesVigenteDetalhe/GetAllSituacaoPedido`)
                .then(response => {
                    this.Situacoes = response.data; //.filter(x=> x.pspId != 1 &&  x.pspId != 3 &&  x.pspId != 5 &&  x.pspId != 6);
                   // console.log('this.Situacoes')
                   // console.log(this.Situacoes)
                });

                axios.get(`/Telas/ContratacoesVigenteDetalhe/GetAllProdutoImagens`)
                        .then(response => {
                            this.ListaProdutosImg = response.data;
                              //console.log('this.ListaProdutosImg')
                              //console.log(this.ListaProdutosImg)
                     });

         

            this.calculatotal();
        }
    },
    created() {
        this.Get();
    },
    computed: {
    EhPagamentoPorLinkVigente() {
      const formas = [this.PedidosCli?.pedFormaPgto, this.PedidosCli?.pedFormaPgtoEntrada, this.PedidosCli?.pedFormaPgtoParcelas];
      return Number(this.PedidosCli?.pedTipoPgto) === 5 || formas.some(item => String(item || '').toLocaleLowerCase('pt-BR').includes('link de pagamento'));
    },
    ValorTotalPagamentoVigente() {
      const total = this.ValorNumero(this.PedidosCli?.pedValorTotalPedido);
      if (total > 0) return total;
      return this.ValorNumero(this.TotalPedido);
    },
    ValorSetupVigente() {
      const pedido = this.ValorNumero(this.PedidosCli?.pedValorSetup);
      if (pedido > 0) return pedido;
      return this.ValorNumero(this.ListaPedidoItem?.[0]?.pdiCampoExtra1);
    },
    EhAssinaturaFisica() {
      return String(this.PedidosCli?.pedObsCliente || '').toLocaleLowerCase('pt-BR').includes('assinado fisicamente');
    },
    analisesCredito() {
      return [
        {
            titulo: 'Cliente',
            nome: this.Cliente.cliNomeEmpresa,
            documento: this.Cliente.cliDocumento,
            consultas: this.ConsultasCliente,
        },
        {
            titulo: 'Cônjuge',
            nome: this.Cliente.cliNomeConjuge,
            documento: this.Cliente.cliCpfConjuge,
            consultas: this.ConsultasConjuge,
        },
        {
            titulo: 'Corresponsável',
            nome: this.Cliente.cliNomeCorresponsavel,
            documento: this.Cliente.cliCpfCorresponsavel,
            consultas: this.ConsultasCorresp1,
        },
        {
            titulo: 'Corresponsável 2',
            nome: this.Cliente.cliNomeCorresponsavel2,
            documento: this.Cliente.cliCpfCorresponsavel2,
            consultas: this.ConsultasCorresp2,
        },
      ];
    },
    uniqueDocumentos() {
      // Cria uma lista única com base em `pmsNome`
      const seen = new Set();
      return this.ListDocumentos.filter(option => {
        const isDuplicate = seen.has(option.pmsNome);
        seen.add(option.pmsNome);
        return !isDuplicate;
      });
    },
  },
}
</script>

<style scoped>
.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}


td {
    /*border: 1px solid #333333;*/
    padding: 3px;
}

@media (min-width:1200px) {
    .controlcelEnd {
    height: 600px;
        width: calc(100% - 248px) !important;
        display: flex;
        flex-direction: column;
    }

}

.bg-custom-white {
    background-color: white;
}

.bg-custom-light-blue {
    background-color: #c5dce7; /* Customize conforme necessário */
}
.gp-active-detail-card{overflow:hidden;border:1px solid #e1d9cd;border-radius:14px}.gp-active-detail-card>.card-header{padding:13px 17px}.gp-active-detail-card>.card-body{padding:0}.gp-active-detail-card :deep(.gp-client-tabs){padding:8px 14px 0;border-bottom:1px solid #e8e1d7;background:#fcfaf7}.gp-active-detail-card :deep(.v-tab){gap:6px;font-size:11px!important;font-weight:700}.gp-active-detail-card :deep(.v-window-item>.v-form>.v-container){max-width:none;padding:16px}.gp-active-detail-card :deep(.v-card){padding:15px!important;border:1px solid #e1d9cd!important;border-radius:12px!important;background:#fff!important;color:#4d586d!important;box-shadow:none!important}.gp-active-detail-card :deep(h5.subtitulo){display:flex;align-items:center;min-height:38px;margin:-15px -15px 14px!important;padding:11px 15px!important;border-bottom:1px solid #e8e1d7;background:#fcfaf7;color:#102a5a;font-size:13px!important;font-weight:800}.gp-active-detail-card :deep(.texto-mensagem),.gp-active-detail-card :deep(.pedido_dados){margin-bottom:6px!important;color:#4d586d!important;font-size:11.5px!important;line-height:1.45}.gp-active-detail-card :deep(.pedido_dados .v-icon){margin-left:4px;color:#1d4f9f;cursor:pointer}.gp-active-detail-card :deep(.descricao-pedido){border-color:#eee7dd!important}.gp-active-detail-card :deep(.descricao-img img){max-height:92px;border:1px solid #e8e1d7!important;border-radius:10px!important;object-fit:contain}.gp-active-detail-card :deep(.v-table){overflow:hidden;margin:10px 0;border:1px solid #e8e1d7;border-radius:10px;font-size:10.5px}.gp-active-detail-card :deep(.v-table th){background:#f1ede7;color:#42506a;font-size:9px;font-weight:800;text-transform:uppercase}.gp-active-detail-card :deep(.v-field),.gp-active-detail-card :deep(.form-control){border-radius:9px;font-size:11.5px}.gp-active-detail-card :deep(textarea.form-control){min-height:72px;resize:vertical;background:#faf9f7}.gp-active-detail-card :deep(.btn){min-height:34px;padding:7px 13px!important;border:0;border-radius:9px;font-size:11px!important;font-weight:700;box-shadow:none}.gp-active-detail-card :deep(.btn-info){background:#3fa7f5;color:#fff!important}.gp-active-detail-card :deep(.btn-success){background:#e77900;color:#fff!important}.gp-active-detail-card :deep(.btn-danger){background:#dc3545;color:#fff!important}
.gp-active-detail-dialog :deep(.v-overlay__content){width:min(1160px,calc(100vw - 36px))!important;max-width:1160px!important;margin:18px!important}.gp-active-detail-dialog :deep(.v-overlay__content>.v-card){overflow:hidden;border:1px solid #e1d9cd;border-radius:14px;background:#fff;box-shadow:0 18px 50px rgba(16,42,90,.2)}.gp-active-detail-dialog :deep(.v-card-title){display:flex;align-items:center;min-height:56px;padding:13px 18px!important;border-bottom:1px solid #e8e1d7;background:#fcfaf7!important;color:#102a5a}.gp-active-detail-dialog :deep(.v-card-title .text-h5){font-size:14px!important;font-weight:800}.gp-active-detail-dialog :deep(.v-card-text){max-height:72vh;overflow:auto;padding:16px 18px!important;color:#4d586d}.gp-active-detail-dialog :deep(.v-card-text>.v-form>.v-container),.gp-active-detail-dialog :deep(.v-card-text>.v-container){max-width:none;padding:0}.gp-active-detail-dialog :deep(.v-col){font-size:11px}.gp-active-detail-dialog :deep(.v-table){overflow:hidden;border:1px solid #e8e1d7;border-radius:10px;font-size:10px}.gp-active-detail-dialog :deep(.v-table th){background:#f1ede7;color:#42506a;font-size:9px;text-transform:uppercase}.gp-active-detail-dialog :deep(.v-card-actions){gap:8px;min-height:58px;padding:11px 18px!important;border-top:1px solid #e8e1d7;background:#fcfaf7}.gp-active-detail-dialog :deep(.v-card-actions .v-btn){min-height:34px;padding:0 13px;border:1px solid #9ba4b0;border-radius:9px;background:#fff;color:#4f5b6d;font-size:10.5px;font-weight:700}.gp-active-detail-dialog :deep(.v-card-actions .v-btn:first-of-type:not(:last-of-type)){border-color:#e77900;background:#e77900;color:#fff}
.gp-physical-contract-upload{margin-top:9px}.gp-physical-contract-upload .btn{display:inline-flex;align-items:center;gap:5px;border:1px solid #b9cff0!important;background:#fff!important;color:#0756b3!important}
.gp-vigente-heading{gap:12px}.gp-vigente-heading>div:first-child{display:flex;flex-direction:column}.gp-vigente-heading .card-title{color:#102a5a;font-size:15px;font-weight:800}.gp-vigente-heading small,.gp-vigente-heading>div:first-child>span{color:#61708a;font-size:10px}.gp-vigente-heading>div:first-child>span{display:flex;align-items:center;gap:4px;margin-top:3px}.gp-vigente-heading-actions{display:flex;align-items:center;gap:7px;margin-left:auto}.gp-vigente-heading-actions .btn{display:inline-flex;align-items:center;gap:5px;min-height:32px;padding:6px 10px!important;border-radius:8px;font-size:10px!important}.gp-vigente-status{display:inline-flex;align-items:center;gap:5px;padding:6px 10px;border-radius:999px;background:#e8f6ef;color:#087443;font-size:10px;font-weight:800}.gp-vigente-reprocess{border:1px solid #b9cff0!important;background:#fff!important;color:#0756b3!important}.gp-vigente-cancel{border:1px solid #efb8b8!important;background:#fff!important;color:#c62828!important}.gp-vigente-overview{padding:14px 16px 0;background:#fff}.gp-vigente-overview-main{display:grid;grid-template-columns:1.25fr 1.25fr .8fr .8fr;gap:10px}.gp-vigente-overview-main>div{position:relative;display:flex;min-width:0;flex-direction:column;padding:11px 13px;border:1px solid #e8e1d7;border-radius:11px;background:#fcfaf7}.gp-vigente-overview-main small,.gp-vigente-product-config small{color:#7a8495;font-size:9px;font-weight:700;text-transform:uppercase}.gp-vigente-overview-main strong{overflow:hidden;color:#102a5a;font-size:12px;text-overflow:ellipsis;white-space:nowrap}.gp-vigente-overview-main span{overflow:hidden;margin-top:2px;color:#718096;font-size:10px;text-overflow:ellipsis;white-space:nowrap}.gp-vigente-overview-main .gp-vigente-value{color:#087443;font-size:14px}.gp-vigente-access{padding-right:50px!important}.gp-vigente-access>button{position:absolute;top:50%;right:12px;display:grid;width:31px;height:31px;place-items:center;transform:translateY(-50%);border:1px solid #b9cff0;border-radius:8px;background:#fff;color:#0756b3}.gp-vigente-context-grid{display:grid;grid-template-columns:.9fr 1.6fr;gap:10px;margin-top:10px}.gp-vigente-context-grid>article{display:flex;min-width:0;flex-direction:column;padding:11px 13px;border:1px solid #e1d9cd;border-radius:11px;background:#fff;color:#4d586d}.gp-vigente-context-grid article>header{display:flex;align-items:center;gap:6px;margin-bottom:8px;color:#102a5a}.gp-vigente-context-grid article>header .v-icon{color:#d96d00}.gp-vigente-context-grid article>header strong{font-size:11px;font-weight:800}.gp-vigente-context-grid article>strong{color:#263751;font-size:11px}.gp-vigente-context-grid article>span,.gp-vigente-context-grid article>small{margin-top:2px;color:#718096;font-size:9.5px}.gp-vigente-product-row{display:grid;grid-template-columns:minmax(160px,1fr) auto auto;align-items:center;gap:10px;padding:7px 0;border-top:1px dashed #e8e1d7}.gp-vigente-product-row>div:first-child{display:flex;min-width:0;flex-direction:column}.gp-vigente-product-row>div:first-child strong{color:#263751;font-size:10.5px}.gp-vigente-product-row span{color:#718096;font-size:9px}.gp-vigente-product-config{display:flex;gap:6px}.gp-vigente-product-config>span{display:flex;min-width:74px;flex-direction:column;padding:5px 8px;border:1px solid #e7e0d6;border-radius:8px;background:#fcfaf7}.gp-vigente-product-config strong{color:#263751;font-size:10px}.gp-vigente-product-value{color:#087443;font-size:11px;white-space:nowrap}.gp-vigente-additionals{display:flex;flex-wrap:wrap;gap:5px;padding-top:6px;border-top:1px dashed #e8e1d7}.gp-vigente-additionals span{padding:3px 6px;border-radius:6px;background:#f3f6fa;color:#536176;font-size:8.5px}.gp-vigente-legacy-summary,.gp-vigente-legacy-products,.gp-vigente-legacy-cancel{display:none!important}
@media(min-width:1200px){.controlcelEnd.gp-active-detail-dialog{width:auto!important;height:auto}}
@media(max-width:767.98px){.gp-active-detail-card :deep(.v-window-item>.v-form>.v-container){padding:10px}.gp-active-detail-card :deep(.v-card){padding:13px!important}.gp-active-detail-card :deep(h5.subtitulo){margin:-13px -13px 12px!important}.gp-active-detail-dialog :deep(.v-overlay__content){width:calc(100vw - 20px)!important;margin:10px!important}.gp-active-detail-dialog :deep(.v-card-text){max-height:75vh;padding:12px!important}.gp-active-detail-dialog :deep(.v-col[style*="border-right"]){border-right:0!important}.gp-active-detail-dialog :deep(.v-card-actions){align-items:stretch;flex-direction:column}.gp-active-detail-dialog :deep(.v-card-actions .v-btn){width:100%}}

@media(max-width:767.98px){.gp-vigente-heading{align-items:flex-start!important;flex-direction:column}.gp-vigente-heading-actions{flex-wrap:wrap;margin-left:0}.gp-vigente-overview-main,.gp-vigente-context-grid{grid-template-columns:1fr}.gp-vigente-product-row{grid-template-columns:1fr}.gp-vigente-product-config{flex-wrap:wrap}}
.gp-vigente-contract-panel{max-width:none!important;padding:16px!important}.gp-vigente-contract-panel>section{overflow:hidden;border:1px solid #e1d9cd;border-radius:12px;background:#fff}.gp-vigente-contract-panel>section>header{display:flex;align-items:center;justify-content:space-between;padding:12px 15px;border-bottom:1px solid #e8e1d7;background:#fcfaf7}.gp-vigente-contract-panel>section>header>span{display:flex;align-items:center;gap:6px;color:#102a5a}.gp-vigente-contract-panel>section>header strong{font-size:12px}.gp-vigente-contract-status{padding:5px 9px;border-radius:999px;background:#e8f6ef;color:#087443!important;font-size:9.5px;font-weight:800}.gp-vigente-contract-document{display:flex;align-items:center;gap:10px;margin:12px;padding:11px;border:1px solid #e8e1d7;border-radius:10px;background:#fcfaf7}.gp-vigente-contract-document>span{display:grid;width:34px;height:34px;place-items:center;border-radius:8px;background:#fff0f2;color:#d92345}.gp-vigente-contract-document>div{display:flex;flex:1;flex-direction:column}.gp-vigente-contract-document small{color:#7a8495;font-size:8.5px}.gp-vigente-contract-document strong{color:#102a5a;font-size:11px}.gp-vigente-contract-document button,.gp-vigente-contract-panel footer button{display:inline-flex;align-items:center;gap:5px;padding:6px 9px;border:0;background:transparent;color:#0756b3;font-size:9.5px;font-weight:700}.gp-vigente-contract-panel footer{display:flex;align-items:center;gap:10px;padding:10px 13px;border-top:1px solid #e8e1d7}.gp-vigente-contract-panel footer button{border:1px solid #b9cff0;border-radius:8px;background:#fff}.gp-vigente-contract-panel footer small{color:#718096;font-size:9px}@media(max-width:767.98px){.gp-vigente-contract-panel>section>header,.gp-vigente-contract-document,.gp-vigente-contract-panel footer{align-items:flex-start;flex-direction:column}}
.gp-vigente-product-row{grid-template-columns:minmax(160px,1fr) auto}.gp-vigente-legacy-tabs{display:none!important}.gp-vigente-progress{display:grid;grid-template-columns:repeat(6,1fr);margin-top:12px;padding:10px;border:1px solid #d8eadf;border-radius:11px;background:#fff}.gp-vigente-progress-step{position:relative;display:flex;align-items:center;gap:7px;min-width:0;color:#198754}.gp-vigente-progress-step:not(:last-child):after{position:absolute;top:50%;right:6px;left:42px;height:2px;content:'';background:#67d49a}.gp-vigente-progress-step>span{z-index:1;display:grid;width:26px;height:26px;flex:0 0 26px;place-items:center;border:1px solid #67d49a;border-radius:50%;background:#e8f8f0;color:#087443;font-size:10px;font-weight:800}.gp-vigente-progress-step>div{z-index:1;display:flex;min-width:0;flex-direction:column;padding-right:8px;background:#fff}.gp-vigente-progress-step strong{color:#087443;font-size:9.5px}.gp-vigente-progress-step small{color:#5d8a72;font-size:7.5px}.gp-vigente-progress-step.is-current>span{border-color:#087443;background:#087443;color:#fff}.gp-vigente-section-nav{display:flex;gap:3px;margin-top:12px;padding:5px;border:1px solid #e8e1d7;border-radius:11px;background:#f8f6f2}.gp-vigente-section-nav button{display:inline-flex;align-items:center;gap:5px;min-height:32px;padding:6px 12px;border:0;border-radius:8px;background:transparent;color:#536176;font-size:9.5px;font-weight:700}.gp-vigente-section-nav button.is-active{background:#fff;color:#102a5a;box-shadow:0 2px 8px rgba(16,42,90,.08)}@media(max-width:900px){.gp-vigente-progress{grid-template-columns:repeat(3,1fr);row-gap:10px}.gp-vigente-progress-step:nth-child(3):after{display:none}.gp-vigente-section-nav{overflow-x:auto}.gp-vigente-section-nav button{flex:0 0 auto}}
.gp-vigente-documents-wrap{max-width:none!important;padding:16px!important}.gp-vigente-documents-panel{overflow:hidden;border:1px solid #e1d9cd;border-radius:12px;background:#fff}.gp-vigente-documents-panel>header{display:flex;align-items:center;gap:10px;padding:12px 15px;border-bottom:1px solid #e8e1d7;background:#fcfaf7}.gp-vigente-documents-panel>header>span{display:grid;width:34px;height:34px;place-items:center;border-radius:9px;background:#fff1df;color:#d96d00}.gp-vigente-documents-panel>header>div{display:flex;flex:1;flex-direction:column}.gp-vigente-documents-panel>header strong{color:#102a5a;font-size:12px}.gp-vigente-documents-panel>header small{color:#718096;font-size:9px}.gp-vigente-documents-panel>header em{padding:4px 8px;border-radius:999px;background:#edf3fa;color:#536176;font-size:8.5px;font-style:normal;font-weight:700}.gp-vigente-document-upload{display:grid;grid-template-columns:minmax(210px,.8fr) minmax(300px,1.4fr) auto;align-items:end;gap:10px;margin:12px;padding:12px;border:1px solid #e8e1d7;border-radius:10px;background:#fcfaf7}.gp-vigente-document-upload label{display:flex;min-width:0;flex-direction:column;gap:5px}.gp-vigente-document-upload label>span{color:#536176;font-size:9px;font-weight:700}.gp-vigente-document-upload input{min-height:40px;border:1px solid #d8d2c9}.gp-vigente-file-field :deep(.v-field){min-height:40px;background:#fff}.gp-vigente-document-upload>button{display:inline-flex;align-items:center;justify-content:center;gap:5px;min-height:40px!important;padding:0 14px!important;background:#e77900!important;color:#fff!important;white-space:nowrap}.gp-vigente-document-list{margin:0 12px 12px;border:1px solid #e8e1d7;border-radius:10px}.gp-vigente-document-item{display:flex;align-items:center;gap:9px;padding:10px 12px;border-bottom:1px solid #eee8df}.gp-vigente-document-item:last-child{border-bottom:0}.gp-vigente-document-item>span{display:grid;width:31px;height:31px;place-items:center;border-radius:8px;background:#edf4fc;color:#0756b3}.gp-vigente-document-item>div{display:flex;flex:1;flex-direction:column}.gp-vigente-document-item strong{color:#263751;font-size:10.5px}.gp-vigente-document-item small{color:#8490a2;font-size:8.5px}.gp-vigente-document-item button{display:inline-flex;align-items:center;gap:5px;padding:6px 9px;border:1px solid #b9cff0;border-radius:8px;background:#fff;color:#0756b3;font-size:9px;font-weight:700}.gp-vigente-document-empty{display:flex;min-height:135px;align-items:center;justify-content:center;flex-direction:column;margin:0 12px 12px;border:1px dashed #d8d2c9;border-radius:10px;color:#8a94a5}.gp-vigente-document-empty strong{margin-top:5px;color:#536176;font-size:10.5px}.gp-vigente-document-empty span{font-size:9px}@media(max-width:767.98px){.gp-vigente-document-upload{grid-template-columns:1fr}.gp-vigente-document-item{align-items:flex-start;flex-wrap:wrap}.gp-vigente-document-item>div{min-width:calc(100% - 44px)}}
.gp-vigente-payment-wrap{max-width:none!important;padding:16px!important}.gp-vigente-payment-panel{overflow:hidden;border:1px solid #e1d9cd;border-radius:12px;background:#fff}.gp-vigente-payment-panel>header{display:flex;align-items:center;gap:10px;padding:12px 15px;border-bottom:1px solid #e8e1d7;background:#fcfaf7}.gp-vigente-payment-panel>header>span{display:grid;width:34px;height:34px;place-items:center;border-radius:9px;background:#fff1df;color:#d96d00}.gp-vigente-payment-panel>header>div{display:flex;flex:1;flex-direction:column}.gp-vigente-payment-panel>header strong{color:#102a5a;font-size:12px}.gp-vigente-payment-panel>header small{color:#718096;font-size:9px}.gp-vigente-payment-panel>header em{display:inline-flex;align-items:center;gap:4px;padding:5px 8px;border-radius:999px;background:#edf3fa;color:#536176;font-size:8.5px;font-style:normal;font-weight:700}.gp-vigente-payment-summary{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:9px;padding:12px}.gp-vigente-payment-summary.is-link{grid-template-columns:repeat(2,minmax(0,1fr))}.gp-vigente-payment-summary article{display:flex;min-width:0;flex-direction:column;padding:11px 13px;border:1px solid #e8e1d7;border-radius:10px;background:#fcfaf7}.gp-vigente-payment-summary small{color:#7a8495;font-size:8.5px;font-weight:700;text-transform:uppercase}.gp-vigente-payment-summary strong{margin-top:2px;color:#102a5a;font-size:12px}.gp-vigente-payment-summary span{overflow:hidden;margin-top:2px;color:#718096;font-size:9px;text-overflow:ellipsis;white-space:nowrap}@media(max-width:767.98px){.gp-vigente-payment-summary,.gp-vigente-payment-summary.is-link{grid-template-columns:1fr}.gp-vigente-payment-panel>header{align-items:flex-start;flex-wrap:wrap}.gp-vigente-payment-panel>header em{margin-left:44px}}
</style>
